import { NgIf, CommonModule, isPlatformBrowser, DOCUMENT } from '@angular/common';
import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵelementStart, ɵɵelement, ɵɵelementEnd, ɵɵdirectiveInject, ɵɵdefineComponent, ɵɵtemplate, ɵɵproperty, Component, ComponentFactoryResolver, ViewContainerRef, Injector, ɵɵdefineDirective, ɵɵProvidersFeature, Directive, Input, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵinject, PLATFORM_ID, Inject, EventEmitter, ɵɵdefinePipe, Pipe } from '@angular/core';
import { Subscription, Observable, of, timer, Subject, EMPTY } from 'rxjs';
import { style, trigger, transition, animate } from '@angular/animations';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams, HttpHeaders, HttpRequest } from '@angular/common/http';
import { ToasterService } from 'angular2-toaster';
import { OK, NO_CONTENT, BAD_REQUEST, INTERNAL_SERVER_ERROR, CONFLICT, FORBIDDEN, NOT_FOUND } from 'http-status-codes';
import moment from 'moment-timezone';
import { TranslateService } from '@ngx-translate/core';
import moment$1 from 'moment';
import { configureScope, captureException } from '@sentry/browser';
import { Angulartics2 } from 'angulartics2';
import { flatMap } from 'rxjs/internal/operators';

var SearchDocumentTypeEnum;
(function (SearchDocumentTypeEnum) {
    SearchDocumentTypeEnum["CLUB"] = "CLUB";
    SearchDocumentTypeEnum["CLUBGROUP"] = "CLUBGROUP";
})(SearchDocumentTypeEnum || (SearchDocumentTypeEnum = {}));

let APP_INJECTOR;
class CommonUtil {
    static setInjector(injector) {
        APP_INJECTOR = injector;
    }
    static getApiBaseURL() {
        return 'http://' + location.hostname + ':8080/api'; // todo: use v2 => maybe use getBaseURL...
    }
    static parseSearchDocumentType(statusString) {
        return SearchDocumentTypeEnum[statusString];
    }
    static isDate(obj) {
        return Object.prototype.toString.call(obj) === '[object Date]';
    }
    static isString(obj) {
        return typeof obj == 'string';
    }
    static isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    /**
     * Filter out the HTML comments and style tags (and all styles contained by these tags)
     * @param message
     */
    static filterTextFromCommentsAndStyling(message) {
        message = message.replace(/(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g, '');
        message = message.replace(/<style([\S\s]*?)>([\S\s]*?)<\/style>/ig, '');
        return message;
    }
    static checkPassWordStrength(password) {
        let errors = {};
        let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if (password.length < 8) {
            errors.length = false;
        }
        else {
            errors.length = true;
        }
        if (!password.match(/\d/)) {
            errors.number = false;
        }
        else {
            errors.number = true;
        }
        if (!password.match(/[A-Z]/)) {
            errors.capital = false;
        }
        else {
            errors.capital = true;
        }
        if (!format.test(password)) {
            errors.specialChar = false;
        }
        else {
            errors.specialChar = true;
        }
        if (!password.match(/[a-z]/)) {
            errors.lower = false;
        }
        else {
            errors.lower = true;
        }
        if (password.startsWith(' ')) {
            errors.startingSpace = true;
        }
        else {
            errors.startingSpace = false;
        }
        if (password.endsWith(' ')) {
            errors.endingSpace = true;
        }
        else {
            errors.endingSpace = false;
        }
        return errors;
    }
    static checkInvalidPassword(passwordChecks) {
        return (!passwordChecks.capital || !passwordChecks.length || !passwordChecks.lower || !passwordChecks.number
            || !passwordChecks.specialChar || passwordChecks.endingSpace || passwordChecks.startingSpace);
    }
    static getBaseURL(prefix, type = 'api', isProduction = false, domainExtension = 'prosoccerdata.com') {
        let baseURL = '';
        let domain = domainExtension;
        if (type == 'public-app') {
            domain = 'prosoccerdata.com';
        }
        let protocol = 'http://';
        let apiPath = '/api';
        let port = '';
        if (isProduction) {
            protocol = 'https://';
            apiPath = '/api/v2';
        }
        else {
            port = ':8080';
        }
        baseURL = protocol + prefix + '.' + domain;
        if (type == 'api') {
            baseURL += port;
            baseURL += apiPath;
        }
        if (type == 'public-app' && !isProduction) {
            baseURL += ':4041';
        }
        return baseURL;
    }
    /**
     * Compare two parameters (can be objects, strings, numbers, dates)
     * @param o1 object 1
     * @param o2 object 2
     */
    static equals(o1, o2) {
        if (o1 === o2) {
            return true;
        }
        if (o1 === null || o2 === null) {
            return false;
        }
        if (o1 !== o1 && o2 !== o2) {
            return true; // NaN === NaN
        }
        const t1 = typeof o1;
        const t2 = typeof o2;
        let length;
        let key;
        let keySet;
        if (t1 === t2 && t1 === 'object') {
            if (Array.isArray(o1)) {
                if (!Array.isArray(o2)) {
                    return false;
                }
                if ((length = o1.length) === o2.length) {
                    for (key = 0; key < length; key++) {
                        if (!this.equals(o1[key], o2[key])) {
                            return false;
                        }
                    }
                    return true;
                }
            }
            else if (this.isDate(o1)) {
                if (!this.isDate(o2)) {
                    return false;
                }
                return this.equals(o1.getTime(), o2.getTime());
            }
            else if (this.isRegExp(o1)) {
                if (!this.isRegExp(o2)) {
                    return false;
                }
                return o1.toString() === o2.toString();
            }
            else {
                if (this.isWindow(o1) || this.isWindow(o2)
                    || Array.isArray(o2) || this.isDate(o2) || this.isRegExp(o2)) {
                    return false;
                }
                ;
                /*
                keySet = Object.create(null);
                for (key in o1) {
                    if (key.charAt(0) === '$' || isFunction(o1[key])) {
                        continue
                    };
                    if (!equals(o1[key], o2[key])) {
                        return false;
                    }
                    keySet[key] = true;
                }
                for (key in o2) {
                    if (!(key in keySet)
                        && key.charAt(0) !== '$'
                        && isDefined(o2[key])
                        && !isFunction(o2[key])
                    ) {
                        return false;
                    }
                }*/
                return false;
            }
        }
        return false;
    }
    static isRegExp(value) {
        return Object.prototype.toString.call(value) === '[object RegExp]';
    }
    static isWindow(obj) {
        return obj && obj.window === obj;
    }
    static isFunction(value) {
        return typeof value === 'function';
    }
    static isDefined(value) {
        return typeof value !== 'undefined';
    }
    static isValidEmailFormat(email) {
        return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    }
}

class CommonPromiseTrackerService {
    constructor() {
        this.promiseList = [];
        this.delayJustFinished = false;
    }
    reset(options) {
        this.minDuration = options.minDuration;
        this.promiseList = [];
        options.promiseList.forEach(promise => {
            if (!promise || promise['busyFulfilled']) {
                return;
            }
            this.addPromise(promise);
        });
        if (this.promiseList.length === 0) {
            return;
        }
        this.delayJustFinished = false;
        if (options.delay) {
            this.delayPromise = setTimeout(() => {
                this.delayPromise = null;
                this.delayJustFinished = true;
            }, options.delay);
        }
        if (options.minDuration) {
            this.durationPromise = setTimeout(() => {
                this.durationPromise = null;
            }, options.minDuration + (options.delay || 0));
        }
    }
    addPromise(promise) {
        if (this.promiseList.indexOf(promise) !== -1) {
            return;
        }
        this.promiseList.push(promise);
        if (promise instanceof Promise) {
            promise.then.call(promise, () => this.finishPromise(promise), () => this.finishPromise(promise));
        }
        else if (promise instanceof Subscription) {
            promise.add(() => this.finishPromise(promise));
        }
    }
    finishPromise(promise) {
        promise['busyFulfilled'] = true;
        const index = this.promiseList.indexOf(promise);
        if (index === -1) {
            return;
        }
        this.promiseList.splice(index, 1);
    }
    isActive() {
        if (this.delayPromise) {
            return false;
        }
        if (!this.delayJustFinished) {
            if (this.durationPromise) {
                return true;
            }
            return this.promiseList.length > 0;
        }
        this.delayJustFinished = false;
        if (this.promiseList.length === 0) {
            this.durationPromise = null;
        }
        return this.promiseList.length > 0;
    }
}
CommonPromiseTrackerService.ɵfac = function CommonPromiseTrackerService_Factory(t) { return new (t || CommonPromiseTrackerService)(); };
CommonPromiseTrackerService.ɵprov = ɵɵdefineInjectable({ token: CommonPromiseTrackerService, factory: CommonPromiseTrackerService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CommonPromiseTrackerService, [{
        type: Injectable
    }], null, null); })();

function CommonCustomBusyComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "div", 2);
    ɵɵelement(2, "div", 3);
    ɵɵelement(3, "div", 4);
    ɵɵelement(4, "div", 5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
const inactiveStyle = style({
    opacity: 0,
    transform: 'translateY(-40px)'
});
const timing = '.3s ease';
class CommonCustomBusyComponent {
    constructor(tracker) {
        this.tracker = tracker;
    }
    isActive() {
        return this.tracker.isActive();
    }
}
CommonCustomBusyComponent.ɵfac = function CommonCustomBusyComponent_Factory(t) { return new (t || CommonCustomBusyComponent)(ɵɵdirectiveInject(CommonPromiseTrackerService)); };
CommonCustomBusyComponent.ɵcmp = ɵɵdefineComponent({ type: CommonCustomBusyComponent, selectors: [["ng-busy"]], decls: 1, vars: 1, consts: [["class", "psd-loader", 4, "ngIf"], [1, "psd-loader"], [1, "psd-loader__bullets"], [1, "psd-loader__bullet--left"], [1, "psd-loader__bullet--middle"], [1, "psd-loader__bullet--right"]], template: function CommonCustomBusyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, CommonCustomBusyComponent_div_0_Template, 5, 0, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.isActive());
    } }, directives: [NgIf], encapsulation: 2, data: { animation: [trigger('flyInOut', [transition('void => *', [inactiveStyle, animate(timing)]), transition('* => void', [animate(timing, inactiveStyle)])])] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CommonCustomBusyComponent, [{
        type: Component,
        args: [{
                selector: 'ng-busy',
                template: `
        <div class="psd-loader" *ngIf="isActive()">
            <div class="psd-loader__bullets" >
                <div class="psd-loader__bullet--left"></div>
                <div class="psd-loader__bullet--middle"></div>
                <div class="psd-loader__bullet--right"></div>
            </div>
        </div>
    `,
                animations: [trigger('flyInOut', [transition('void => *', [inactiveStyle, animate(timing)]), transition('* => void', [animate(timing, inactiveStyle)])])]
            }]
    }], function () { return [{ type: CommonPromiseTrackerService }]; }, null); })();

class CommonBusyDirective {
    constructor(tracker, cfResolver, vcRef, injector) {
        this.tracker = tracker;
        this.cfResolver = cfResolver;
        this.vcRef = vcRef;
        this.injector = injector;
    }
    normalizeSubscriptions(originalSubscriptions) {
        let subscriptions = [];
        if (!originalSubscriptions) {
            subscriptions = null;
        }
        else if (Array.isArray(originalSubscriptions)) {
            subscriptions = originalSubscriptions;
        }
        else if (originalSubscriptions instanceof Promise || originalSubscriptions instanceof Subscription) {
            subscriptions = [originalSubscriptions];
        }
        if (!Array.isArray(subscriptions)) {
            subscriptions = [originalSubscriptions];
        }
        return subscriptions;
    }
    // As ngOnChanges does not work on Object detection, ngDoCheck is using
    ngDoCheck() {
        let subscriptions = this.normalizeSubscriptions(this.busySubscriptions);
        let reset = !CommonUtil.equals(subscriptions, this.tracker.promiseList) &&
            this.tracker.reset({
                promiseList: subscriptions,
                delay: 0,
                minDuration: 0
            });
        if (!this.busyRef) {
            this.destroyComponents();
            this.createBusy();
        }
    }
    ngOnDestroy() {
        this.destroyComponents();
    }
    destroyComponents() {
        let busyDestroy = this.busyRef && this.busyRef.destroy();
    }
    createBusy() {
        const busyFactory = this.cfResolver.resolveComponentFactory(CommonCustomBusyComponent);
        this.busyRef = this.vcRef.createComponent(busyFactory, null, this.injector);
    }
}
CommonBusyDirective.ɵfac = function CommonBusyDirective_Factory(t) { return new (t || CommonBusyDirective)(ɵɵdirectiveInject(CommonPromiseTrackerService), ɵɵdirectiveInject(ComponentFactoryResolver), ɵɵdirectiveInject(ViewContainerRef), ɵɵdirectiveInject(Injector)); };
CommonBusyDirective.ɵdir = ɵɵdefineDirective({ type: CommonBusyDirective, selectors: [["", "ngCommonBusy", ""]], inputs: { busySubscriptions: ["ngCommonBusy", "busySubscriptions"] }, features: [ɵɵProvidersFeature([CommonPromiseTrackerService])] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CommonBusyDirective, [{
        type: Directive,
        args: [{
                selector: '[ngCommonBusy]',
                providers: [CommonPromiseTrackerService]
            }]
    }], function () { return [{ type: CommonPromiseTrackerService }, { type: ComponentFactoryResolver }, { type: ViewContainerRef }, { type: Injector }]; }, { busySubscriptions: [{
            type: Input,
            args: ['ngCommonBusy']
        }] }); })();

class PsdCommonModule {
}
PsdCommonModule.ɵmod = ɵɵdefineNgModule({ type: PsdCommonModule });
PsdCommonModule.ɵinj = ɵɵdefineInjector({ factory: function PsdCommonModule_Factory(t) { return new (t || PsdCommonModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(PsdCommonModule, { declarations: [CommonCustomBusyComponent, CommonBusyDirective], imports: [CommonModule], exports: [CommonCustomBusyComponent, CommonBusyDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(PsdCommonModule, [{
        type: NgModule,
        args: [{
                declarations: [CommonCustomBusyComponent, CommonBusyDirective],
                imports: [CommonModule],
                exports: [CommonCustomBusyComponent, CommonBusyDirective]
            }]
    }], null, null); })();

var PlatformSubscriptionPaymentFlowEnum;
(function (PlatformSubscriptionPaymentFlowEnum) {
    PlatformSubscriptionPaymentFlowEnum["EMAIL"] = "EMAIL";
    PlatformSubscriptionPaymentFlowEnum["BILLING_PAGE"] = "BILLING_PAGE";
})(PlatformSubscriptionPaymentFlowEnum || (PlatformSubscriptionPaymentFlowEnum = {}));

var PlatformPackageEnum;
(function (PlatformPackageEnum) {
    PlatformPackageEnum["START"] = "start";
    PlatformPackageEnum["PROGRESS"] = "progress";
    PlatformPackageEnum["PERFORM"] = "perform";
    PlatformPackageEnum["CUSTOM"] = "custom";
    PlatformPackageEnum["LEGACY"] = "legacy";
})(PlatformPackageEnum || (PlatformPackageEnum = {}));

var ModuleTypeEnum;
(function (ModuleTypeEnum) {
    ModuleTypeEnum["NORMAL"] = "normal";
    ModuleTypeEnum["ADD_ON"] = "add_on";
    ModuleTypeEnum["INTEGRATION"] = "integration";
})(ModuleTypeEnum || (ModuleTypeEnum = {}));

var ModuleSubTypeEnum;
(function (ModuleSubTypeEnum) {
    ModuleSubTypeEnum["REPORTING"] = "REPORTING";
    ModuleSubTypeEnum["PERFORMANCE"] = "PERFORMANCE";
    ModuleSubTypeEnum["ADMINISTRATION"] = "ADMINISTRATION";
})(ModuleSubTypeEnum || (ModuleSubTypeEnum = {}));

var PlatformValidityEnum;
(function (PlatformValidityEnum) {
    PlatformValidityEnum["PLATFORM_VALID"] = "PLATFORM_VALID";
    PlatformValidityEnum["PLATFORM_INVALID_ADMIN"] = "PLATFORM_INVALID_ADMIN";
    PlatformValidityEnum["PLATFORM_INVALID"] = "PLATFORM_INVALID";
})(PlatformValidityEnum || (PlatformValidityEnum = {}));

function deserializeProperties(json, instance) {
    for (let prop in json) {
        if (!json.hasOwnProperty(prop)) {
            continue;
        }
        if (!(typeof json[prop] === 'object')) {
            instance[prop] = json[prop];
        }
    }
    return instance;
}
function deserializeList(list, deserializeFn) {
    let result = new Array();
    if (list != null) {
        for (let item of list) {
            if (item != null) {
                result.push(deserializeFn(item));
            }
        }
    }
    return result;
}

class Country {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
    get uuid() {
        return this.id + '-' + this.dialingCode;
    }
}

class AddClubDTO {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.country != null) {
            this.country = new Country().deserialize(json.country);
        }
        return this;
    }
}

class ApiValidationError {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class ApiError {
    constructor() {
        this.subErrors = [];
    }
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.subErrors != null) {
            this.subErrors = deserializeList(json.subErrors, function (item) {
                return new ApiValidationError().deserialize(item);
            });
        }
        return this;
    }
}

class CentralUserEmailStatusDTO {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class ClubSearchDTO {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.type) {
            this.type = CommonUtil.parseSearchDocumentType(json.type);
        }
        return this;
    }
}

class BaseService {
    constructor() { }
}

class ConfigParamsService extends BaseService {
    constructor(http) {
        super();
        this.http = http;
        this.configParams = {};
    }
    initConfigParams() {
        return Observable.create(observer => {
            this.http
                .get('/config_params.php')
                .pipe(map(params => {
                return params;
            }))
                .subscribe(params => {
                for (let prop in params) {
                    if (params.hasOwnProperty(prop)) {
                        this.configParams[prop] = params[prop];
                    }
                }
                observer.next(params);
                observer.complete();
            });
        });
    }
    clearConfigParam(param) {
        this.configParams[param] = null;
    }
    getConfigParam(param) {
        return this.configParams[param];
    }
    setConfigParam(param, value) {
        this.configParams[param] = value;
    }
}
ConfigParamsService.ɵfac = function ConfigParamsService_Factory(t) { return new (t || ConfigParamsService)(ɵɵinject(HttpClient)); };
ConfigParamsService.ɵprov = ɵɵdefineInjectable({ token: ConfigParamsService, factory: ConfigParamsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ConfigParamsService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

class LinkUtil {
    static getClubLink(id) {
        return '/index.php?module=club&id=' + id;
    }
    static getDashboardLink() {
        return '/index.php';
    }
    static getDefaultEditorField() {
        return 'http://config.prosoccerdata.com/images/editor-field.jpg';
    }
    static getLanguageSwitchLink(language) {
        let url = document.location.href;
        if (url.indexOf('.php/') < 0) {
            url = url.replace('.php', '.php/');
        }
        if (url.indexOf('#') >= 0) {
            url = url.substring(0, url.indexOf('#'));
        }
        if (url.indexOf('&taal=') >= 0) {
            url = url.substring(0, url.indexOf('&taal='));
        }
        else if (url.indexOf('?taal=') >= 0) {
            url = url.substring(0, url.indexOf('?taal='));
        }
        url = url.replace('/?', '?');
        if (url.indexOf('?') < 0) {
            url += '?taal=' + language + '&clearcache=1';
        }
        else {
            url += '&taal=' + language + '&clearcache=1';
        }
        return url;
    }
    static getMedicalProfileLink(id) {
        return '/index.php?module=medisch&sub=spelerfiche&id=' + id;
    }
    static getMemberProfilePictureLink(id, ts, baseUrl) {
        return (baseUrl != null ? baseUrl : CommonUtil.getApiBaseURL()) + '/members/profilepicture/' + id + '?' + (ts != null ? '&' + ts : '');
    }
    static getModuleLink(module, sub, page, id) {
        return '/index.php?module=' + module + (sub != null && sub != '' ? '&sub=' + sub : '') + (page != null && page != '' ? '&p=' + page : '') + (id != null && id != '' ? '&id=' + id : '');
    }
    static getNarrowCastingPageHtml(uuid) {
        let configParamsService = APP_INJECTOR.get(ConfigParamsService);
        return configParamsService.getConfigParam('apiBaseURL') + '/narrowcasting/pages/html/' + uuid;
    }
    static getNarrowCastingPreviewPageHtml(uuid) {
        let configParamsService = APP_INJECTOR.get(ConfigParamsService);
        return configParamsService.getConfigParam('apiBaseURL') + '/narrowcasting/pages/html/' + uuid + '?preview=true';
    }
    static getNarrowCastingPreviewTemplateHtml(id) {
        let configParamsService = APP_INJECTOR.get(ConfigParamsService);
        return configParamsService.getConfigParam('apiBaseURL') + '/narrowcasting/templates/html/' + id + '?preview=true';
    }
    static getScoutingTestPlayerLink(reportId) {
        return '/index.php?module=scouting&sub=testspelers&id=' + reportId;
    }
    static getLittleLogoClub(clubId, clubVersionId) {
        return 'https://config.prosoccerdata.com/logos/klein/' + clubId + '.png?v=' + clubVersionId;
    }
    static getBigLogoClub(clubId, clubVersionId) {
        return 'https://config.prosoccerdata.com/logos/groot/' + clubId + '.png?v=' + clubVersionId;
    }
    static getExtraBigLogoClub(clubId, clubVersionId) {
        return 'https://config.prosoccerdata.com/logos/extra_groot/' + clubId + '.png?v=' + clubVersionId;
    }
    static getSportiveGamesLink() {
        return '/index.php/sportief/wedstrijden?module=sportief&sub=wedstrijden';
    }
    static getSportiveTrainingsLink() {
        return '/index.php?module=sportief&sub=trainingen';
    }
    static getTrainingCenterPagesURL(trainingCenterId, trainingCenterGroupId) {
        return 'https://d1kmco2rzrtjz4.cloudfront.net/delegate/prizmdoc?articleId=' + trainingCenterId + '&groupId=' + trainingCenterGroupId + '&type=view&' + new Date().getTime();
    }
    static getMemberProfile(memberId) {
        return 'index.php/user?module=user&id=' + memberId;
    }
}

class ClubTranslation {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class UserUtil {
    static getUserLanguage() {
        if (UserUtil.getCookie('lang') != null) {
            return UserUtil.getCookie('lang');
        }
        else {
            return navigator.language || window.navigator.language;
        }
    }
    static getCookie(name) {
        const nameLenPlus = name.length + 1;
        return (document.cookie
            .split(';')
            .map(c => c.trim())
            .filter(cookie => {
            return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
            .map(cookie => {
            return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || null);
    }
}

class Club {
    constructor() {
        this.id = null;
    }
    deserialize(json) {
        deserializeProperties(json, this);
        if (json != null) {
            if (json.country != null) {
                this.country = new Country().deserialize(json.country);
            }
            if (json.clubTranslations != null) {
                this.clubTranslations = deserializeList(json.clubTranslations, function (item) {
                    return new ClubTranslation().deserialize(item);
                });
            }
        }
        return this;
    }
    get name() {
        if (this.translatedName == null) {
            if (this.clubTranslations != null) {
                for (let clubTranslation of this.clubTranslations) {
                    if (clubTranslation.language == UserUtil.getUserLanguage()) {
                        this.translatedName = clubTranslation.label;
                    }
                }
            }
            if (this.translatedName == null) {
                this.translatedName = this._name;
            }
        }
        return this.translatedName;
    }
    set name(name) {
        this._name = name;
    }
    get abbreviation() {
        if (this.translatedAbbreviation == null) {
            if (this.clubTranslations != null) {
                for (let clubTranslation of this.clubTranslations) {
                    if (clubTranslation.language == UserUtil.getUserLanguage()) {
                        this.translatedAbbreviation = clubTranslation.label;
                    }
                }
            }
            if (this.translatedAbbreviation == null) {
                this.translatedAbbreviation = this._abbreviation;
            }
        }
        return this.translatedAbbreviation;
    }
    get abbreviationWithLogo() {
        if (this.translatedAbbreviation == null) {
            if (this.clubTranslations != null) {
                for (let clubTranslation of this.clubTranslations) {
                    if (clubTranslation.language == UserUtil.getUserLanguage()) {
                        this.translatedAbbreviation = clubTranslation.label;
                    }
                }
            }
            if (this.translatedAbbreviation == null) {
                this.translatedAbbreviation = this._abbreviation;
            }
        }
        return '<img src="' + this.logoSmall + '" class="ml-2 mr-2" > ' + this.translatedAbbreviation;
    }
    set abbreviation(abbreviation) {
        this._abbreviation = abbreviation;
    }
    get clubLink() {
        return LinkUtil.getClubLink(this.id);
    }
}

class CreateCentralUserDTO {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class Language {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class LabelTranslation {
    constructor(language) {
        if (language) {
            this.language = language;
        }
        else {
            this.language = UserUtil.getUserLanguage();
        }
    }
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class Translatable {
    constructor() {
        this.labelTranslations = new Array();
        this.secondLabelTranslations = new Array();
    }
    deserialize(json) {
        if (json != null) {
            if (json.labelTranslations != null) {
                for (let lt of json.labelTranslations) {
                    this.labelTranslations.push(new LabelTranslation().deserialize(lt));
                }
            }
            if (json.secondLabelTranslations != null) {
                for (let lt of json.secondLabelTranslations) {
                    this.secondLabelTranslations.push(new LabelTranslation().deserialize(lt));
                }
            }
        }
        return null;
    }
    get label() {
        return this.getLabel();
    }
    get secondLabel() {
        return this.getSecondLabel();
    }
    initTranslations() {
        if (this.labelTranslations == null || this.labelTranslations.length == 0) {
            this.labelTranslations = new Array();
            this.labelTranslations.push(new LabelTranslation());
        }
        if (this.secondLabelTranslations == null || this.secondLabelTranslations.length == 0) {
            this.secondLabelTranslations = new Array();
            this.secondLabelTranslations.push(new LabelTranslation());
        }
    }
    getLabel() {
        let label = null;
        let fallbackLabel = null;
        let userLanguage = UserUtil.getUserLanguage();
        if (this.labelTranslations != null) {
            for (let lt of this.labelTranslations) {
                if (fallbackLabel == null) {
                    fallbackLabel = lt.value;
                }
                if (userLanguage == lt.language) {
                    label = lt.value;
                }
            }
        }
        return label != null ? label : fallbackLabel;
    }
    getSecondLabel() {
        let label = null;
        let fallbackLabel = null;
        let userLanguage = UserUtil.getUserLanguage();
        if (this.secondLabelTranslations != null) {
            for (let lt of this.secondLabelTranslations) {
                if (fallbackLabel == null) {
                    fallbackLabel = lt.value;
                }
                if (userLanguage == lt.language) {
                    label = lt.value;
                }
            }
        }
        return label != null ? label : fallbackLabel;
    }
}

class Certificate extends Translatable {
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        return this;
    }
}

class Contract {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class Housing {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.country != null) {
            this.country = new Country().deserialize(json.country);
        }
        return this;
    }
    get address() {
        return this.street + ' ' + this.number + '<br/>' + this.zipCode + ' ' + this.city;
    }
}

class CentralPosition {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
    get positionX() {
        return ((this.x - 50) * 100) / 358;
    }
    get positionY() {
        return (this.y * 100) / 493;
    }
    get style() {
        return 'left: ' + this.x + '%; top: ' + this.y + '%';
    }
}

class PositionType extends Translatable {
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        return this;
    }
}

class Position {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.centralPosition != null) {
            this.centralPosition = new CentralPosition().deserialize(json.centralPosition);
        }
        if (json.type != null) {
            this.type = new PositionType().deserialize(json.type);
        }
        return this;
    }
    set positionId(positionId) {
        this.id = positionId;
    }
    get positionX() {
        return ((this.x - 50) * 100) / 358;
    }
    get positionY() {
        return (this.y * 100) / 493;
    }
    get style() {
        return 'left: ' + this.centralPosition.x + '%; top: ' + this.centralPosition.y + '%';
    }
}

class TrainingCenter {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.country != null) {
            this.country = new Country().deserialize(json.country);
        }
        return this;
    }
}

class School {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.contactPersons != null) {
            this.contactPersons = deserializeList(json.contactPersons, function (item) { return new Member().deserialize(item); });
        }
        if (json.country != null) {
            this.country = new Country().deserialize(json.country);
        }
        if (json.trainingCenter != null) {
            this.trainingCenter = new TrainingCenter().deserialize(json.trainingCenter);
        }
        return this;
    }
    get address() {
        return this.street + ' ' + this.number + '<br/>' + this.zipCode + ' ' + this.city;
    }
}

class UserProfile {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class MedicalStatus {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
    get revalidation() {
        return this.type == 'revalidatie';
    }
}

class Actionable {
    constructor() {
        this.actions = {};
    }
    deserialize(json) {
        if (json != null) {
            if (json.actions != null) {
                this.actions = json.actions;
            }
        }
        return null;
    }
    hasAccess(action) {
        let access = false;
        if (this.actions != null && this.actions[action] != null) {
            access = this.actions[action];
        }
        return access;
    }
}

class GameSite extends Translatable {
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        if (json != null && json.country != null) {
            this.country = new Country().deserialize(json.country);
        }
        return this;
    }
    get name() {
        let label = this.getLabel();
        if (label == null || label === '') {
            label = this._name;
        }
        return label;
    }
    set name(name) {
        this._name = name;
    }
}

class Surface {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class Terrain extends Translatable {
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        if (json != null) {
            if (json.surface != null) {
                this.surface = new Surface().deserialize(json.surface);
            }
            if (json.gameSite != null) {
                this.gameSite = new GameSite().deserialize(json.gameSite);
            }
        }
        return this;
    }
    get name() {
        let label = this.getLabel();
        if (label == null || label == '') {
            label = this._name;
        }
        return label;
    }
    set name(name) {
        this._name = name;
    }
}

class FieldOccupation {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class ClothingRoom extends Translatable {
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        if (json.gameSite != null) {
            this.gameSite = new GameSite().deserialize(json.gameSite);
        }
        return this;
    }
    get name() {
        let label = this.getLabel();
        if (label == null || label == '') {
            label = this._name;
        }
        return label;
    }
    set name(name) {
        this._name = name;
    }
}

class TeamAccommodationSchedule {
    constructor() {
        this.before = 0;
        this.after = 0;
        this.during = true;
    }
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class TeamGamePeriod {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.team != null) {
            this.team = new Team().deserialize(json.team);
        }
        return this;
    }
}

class Team {
    constructor() {
        this.polar = false;
    }
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.clothingRooms != null) {
            this.clothingRooms = deserializeList(json.clothingRooms, function (item) {
                return new ClothingRoom().deserialize(item);
            });
        }
        if (json.clothingRoomsVisitors != null) {
            this.clothingRoomsVisitors = deserializeList(json.clothingRoomsVisitors, function (item) {
                return new ClothingRoom().deserialize(item);
            });
        }
        if (json.clothingRoomsReferees != null) {
            this.clothingRoomsReferees = deserializeList(json.clothingRoomsReferees, function (item) {
                return new ClothingRoom().deserialize(item);
            });
        }
        if (json.fieldOccupation != null) {
            this.fieldOccupation = new FieldOccupation().deserialize(json.fieldOccupation);
        }
        if (json.gameSite != null) {
            this.gameSite = new GameSite().deserialize(json.gameSite);
        }
        if (json.terrain != null) {
            this.terrain = new Terrain().deserialize(json.terrain);
        }
        if (json.trainingClothingRooms != null) {
            this.trainingClothingRooms = deserializeList(json.trainingClothingRooms, function (item) {
                return new ClothingRoom().deserialize(item);
            });
        }
        if (json.trainingFieldOccupation != null) {
            this.trainingFieldOccupation = new FieldOccupation().deserialize(json.trainingFieldOccupation);
        }
        if (json.trainingGameSite != null) {
            this.trainingGameSite = new GameSite().deserialize(json.trainingGameSite);
        }
        if (json.trainingTerrain != null) {
            this.trainingTerrain = new Terrain().deserialize(json.trainingTerrain);
        }
        if (json.gameDressingRoomAccommodationSchedule != null) {
            this.gameDressingRoomAccommodationSchedule = new TeamAccommodationSchedule().deserialize(json.gameDressingRoomAccommodationSchedule);
        }
        if (json.gameTerrainAccommodationSchedule != null) {
            this.gameTerrainAccommodationSchedule = new TeamAccommodationSchedule().deserialize(json.gameTerrainAccommodationSchedule);
        }
        if (json.trainingDressingRoomAccommodationSchedule != null) {
            this.trainingDressingRoomAccommodationSchedule = new TeamAccommodationSchedule().deserialize(json.trainingDressingRoomAccommodationSchedule);
        }
        if (json.gamePeriods != null) {
            this.gamePeriods = deserializeList(json.gamePeriods, function (item) {
                return new TeamGamePeriod().deserialize(item);
            });
            this.periods = this.gamePeriods.length;
        }
        else {
            this.periods = null;
        }
        return this;
    }
    get fullName() {
        return this.name;
    }
}

class Foot {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class MemberLanguage {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class CentralTeam {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class ScoutingRating extends Translatable {
    constructor() {
        super(...arguments);
        this.color = '#ffffff';
        this.backgroundColor = '#333333';
    }
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        return this;
    }
    get fullName() {
        return this.label + ((this.description != null && this.description != '') ? ' - ' + this.description : '');
    }
}

class ScoutingActionCodeType extends Translatable {
    constructor() {
        super(...arguments);
        this.color = '#ffffff';
        this.backgroundColor = '#333333';
    }
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        return this;
    }
    get name() {
        let label = this.getLabel();
        if (label == null || label == '') {
            label = this._name;
        }
        return label;
    }
    set name(name) {
        this._name = name;
    }
}

class MemberPosition {
    constructor() {
        this.best = false;
    }
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.position != null) {
            this.position = new Position().deserialize(json.position);
        }
        return this;
    }
}

class Member extends Actionable {
    constructor() {
        super(...arguments);
        this.clubId = 0;
        this.clubInternational = 0;
        this.keeper = false;
        this.external = false;
    }
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        if (json != null) {
            if (json.broker != null) {
                this.broker = new Member().deserialize(json.broker);
            }
            if (json.contract != null) {
                this.contract = new Contract().deserialize(json.contract);
            }
            if (json.housing != null) {
                this.housing = new Housing().deserialize(json.housing);
            }
            if (json.school != null) {
                this.school = new School().deserialize(json.school);
            }
            if (json.soccerNationality != null) {
                this.soccerNationality = new Country().deserialize(json.soccerNationality);
            }
            if (json.userProfile != null) {
                this.userProfile = new UserProfile().deserialize(json.userProfile);
            }
            if (json.medicalStatusDetails != null) {
                this.medicalStatusDetails = new MedicalStatus().deserialize(json.medicalStatusDetails);
            }
            if (json.bestPosition != null) {
                this.bestPosition = new Position().deserialize(json.bestPosition);
            }
            if (json.rating != null) {
                this.rating = new ScoutingRating().deserialize(json.rating);
            }
            if (json.actionCode != null) {
                this.actionCode = new ScoutingActionCodeType().deserialize(json.actionCode);
            }
            if (json.myTeams != null) {
                this.myTeams = deserializeList(json.myTeams, function (item) {
                    return new Team().deserialize(item);
                });
            }
            if (json.teamIds != null) {
                this.teamIds = deserializeList(json.teamIds, function (item) {
                    return Number(item);
                });
            }
            if (json.certificates != null) {
                this.certificates = new Array();
                for (let certificate of json.certificates) {
                    this.certificates.push(new Certificate().deserialize(certificate));
                }
            }
            if (json.nationalities != null) {
                this.nationalities = new Array();
                for (let nationality of json.nationalities) {
                    this.nationalities.push(new Country().deserialize(nationality));
                }
            }
            if (json.positions != null) {
                this.positions = new Array();
                for (let position of json.positions) {
                    this.positions.push(new MemberPosition().deserialize(position));
                }
            }
            if (json.playerFoot != null) {
                this.playerFoot = new Foot().deserialize(json.playerFoot);
            }
            if (json.language != null) {
                this.language = new MemberLanguage().deserialize(json.language);
            }
            if (json.currentClub != null) {
                this.currentClub = new Club().deserialize(json.currentClub);
            }
            if (json.internationalClub != null) {
                this.internationalClub = new Club().deserialize(json.internationalClub);
            }
            if (json.myTeam != null) {
                this.myTeam = new Team().deserialize(json.myTeam);
            }
            if (json.myInternationalCentralTeam != null) {
                this.myInternationalCentralTeam = new CentralTeam().deserialize(json.myInternationalCentralTeam);
            }
            if (json.myInternationalTeam != null) {
                this.myInternationalTeam = new Team().deserialize(json.myInternationalTeam);
            }
            if (json.myCentralTeam != null) {
                this.myCentralTeam = new CentralTeam().deserialize(json.myCentralTeam);
            }
        }
        return this;
    }
    get fullAddress() {
        return (this.address == null || this.address.trim() == '') && (this.city == null || this.city.trim() == '')
            ? ''
            : (this.address != null ? this.address.replace(',', ' ') : '') +
                '<br/>' +
                (this.city != null && this.zipCode != null ? this.zipCode.replace(' ', '-') + ' ' + this.city.replace(',', ' ') : '');
    }
    get fullAddress2() {
        return (this.address2 == null || this.address2.trim() == '') && (this.city2 == null || this.city2.trim() == '')
            ? ''
            : (this.address2 != null ? this.address2.replace(',', ' ') : '') +
                '<br/>' +
                (this.city2 != null && this.zipCode2 != null ? this.zipCode2.replace(' ', '-') + ' ' + this.city2.replace(',', ' ') : '');
    }
    get fullName() {
        // we could inverse the order in case we would need it
        if (this.nickname != null && this.nickname != '') {
            return this.nickname;
        }
        else if (this.lastName == null || this.lastName == '') {
            return this.firstName;
        }
        else if (this.firstName == null || this.firstName == '') {
            return this.lastName;
        }
        else {
            return this.lastName + ' ' + this.firstName;
        }
    }
    set fullName(name) { }
    get fullNameWithClubAndBirthDate() {
        let name = this.fullName;
        let extra = '';
        if (this.birthDate != null && this.birthDate != 0) {
        }
        if (this.club != null) {
            if (extra != '') {
                extra += ' - ';
            }
            extra += this.club;
        }
        if (extra != '') {
            name += ' (' + extra + ')';
        }
        return name;
    }
    get medicalProfileLink() {
        return LinkUtil.getMedicalProfileLink(this.id);
    }
    get player() {
        return this.status == 'speler';
    }
    set player(player) { }
    get profileQueryParams() {
        return {
            module: 'user',
            id: this.id
        };
    }
    get profilePicture() {
        if (this.profilePictureTS == null) {
            // we set some timestamp on the generated picture URL so we can refresh it
            this.profilePictureTS = new Date().getTime();
        }
        return this.federationProfilePictureURL ? this.federationProfilePictureURL :
            LinkUtil.getMemberProfilePictureLink(this.id, this.profilePictureTS);
    }
    get staff() {
        return this.status == 'staff';
    }
    set staff(staff) { }
    get text() {
        return this.fullName;
    }
    set text(txt) {
        // do nothing
    }
    getClub(international) {
        if (international) {
            return this.clubInternational;
        }
        else {
            return this.clubId;
        }
    }
    getTeam(international) {
        if (international) {
            return this.teamInternational;
        }
        else {
            return this.team;
        }
    }
    editProfile() {
        //show profilePicture component
    }
    refreshProfilePicture() {
        this.profilePictureTS = null;
    }
    get searchId() {
        return this.id != null ? this.id : Number(this.centralPsdId);
    }
}

class Group extends Translatable {
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        if (json.trainingCenter != null) {
            this.trainingCenter = new TrainingCenter().deserialize(json.trainingCenter);
        }
        return this;
    }
    get name() {
        let label = this.getLabel();
        if (label == null || label == '') {
            label = this._name;
        }
        return label;
    }
    set name(name) {
        this._name = name;
    }
    get fullName() {
        let _fullName = '';
        if (this.trainingCenter != null) {
            _fullName += this.trainingCenter.name + ' - ';
        }
        _fullName += this.name;
        return _fullName;
    }
}

class Right {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.module != null) {
            this.module = new Module().deserialize(json.module);
        }
        if (json.group != null) {
            this.group = new Group().deserialize(json.group);
        }
        if (json.subModule != null) {
            this.subModule = new Module().deserialize(json.subModule);
        }
        return this;
    }
}

class Module {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.subModules != null) {
            this.subModules = new Array();
            for (let subModule of json.subModules) {
                this.subModules.push(new Module().deserialize(subModule));
            }
        }
        if (json.parent != null) {
            this.parent = new Module().deserialize(json.parent);
        }
        if (json.rights != null) {
            this.rights = new Array();
            for (let right of json.rights) {
                this.rights.push(new Right().deserialize(right));
            }
        }
        return this;
    }
}

class Currency {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class ClubConfig {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class Platform {
    constructor() {
        this.clubApiEnabled = false;
        this.trainerPlatform = false;
        this.test = false;
        this.configValues = {};
    }
    get clubId() {
        if (this.club != null) {
            return this.club.id;
        }
        else {
            return 0;
        }
    }
    getConfigValue(name) {
        let configValue = null;
        if (this.configValues[name]) {
            configValue = this.configValues[name];
        }
        else if (this.configProperties != null) {
            for (let clubConfig of this.configProperties) {
                if (clubConfig.name == name) {
                    configValue = clubConfig.value;
                }
            }
            this.configValues[name] = configValue;
        }
        return configValue;
    }
    deserialize(json) {
        deserializeProperties(json, this);
        if (json != null) {
            if (json.currency != null) {
                this.currency = new Currency().deserialize(json.currency);
            }
            if (json.club != null) {
                this.club = new Club().deserialize(json.club);
            }
            if (json.partnerClub != null) {
                this.partnerClub = new Club().deserialize(json.partnerClub);
            }
            if (json.configProperties != null) {
                this.configProperties = deserializeList(json.configProperties, function (item) {
                    return new ClubConfig().deserialize(item);
                });
            }
            if (json.language != null) {
                this.language = new Language().deserialize(json.language);
            }
            if (json.language != null) {
                this.language = new Language().deserialize(json.language);
            }
        }
        return this;
    }
    isSoccer() {
        return this.type == 'soccer';
    }
    isTennis() {
        return this.type == 'tennis';
    }
    isHockey() {
        return this.type == 'hockey';
    }
    getPlatformType() {
        return this.type;
    }
}

class PlatformPackage {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.modules != null) {
            this.modules = deserializeList(json.modules, function (item) {
                return new Module().deserialize(item);
            });
        }
        return this;
    }
    numberOfNormalModules() {
        if (this.modules && this.modules.length > 0) {
            return this.modules.filter(mod => {
                return mod.moduleType == ModuleTypeEnum.NORMAL;
            }).length;
        }
    }
    getStandardModules() {
        let standardArr = [];
        for (let mod of this.modules) {
            if (mod.moduleType == ModuleTypeEnum.NORMAL) {
                standardArr.push(mod.name.toUpperCase());
            }
        }
        return standardArr;
    }
}

class PlatformUserDto {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class ChangePasswordDTO {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class ResetPasswordDTO {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class SelectUserDTO {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

var ClubTaskTypeEnum;
(function (ClubTaskTypeEnum) {
    ClubTaskTypeEnum["ClubAdd"] = "CLUB_ADD";
    ClubTaskTypeEnum["ClubMerge"] = "CLUB_MERGE";
})(ClubTaskTypeEnum || (ClubTaskTypeEnum = {}));
var CompetitionTypeEnum;
(function (CompetitionTypeEnum) {
    CompetitionTypeEnum["Cup"] = "CUP";
    CompetitionTypeEnum["Friendly"] = "FRIENDLY";
    CompetitionTypeEnum["International"] = "INTERNATIONAL";
    CompetitionTypeEnum["Official"] = "OFFICIAL";
    CompetitionTypeEnum["Tournament"] = "TOURNAMENT";
})(CompetitionTypeEnum || (CompetitionTypeEnum = {}));
var DataSourceTypeEnum;
(function (DataSourceTypeEnum) {
    DataSourceTypeEnum["Dataprovider"] = "DATAPROVIDER";
    DataSourceTypeEnum["Platform"] = "PLATFORM";
    DataSourceTypeEnum["PsdAdmin"] = "PSD_ADMIN";
    DataSourceTypeEnum["Region"] = "REGION";
})(DataSourceTypeEnum || (DataSourceTypeEnum = {}));
var DataTransferDestinationStatusEnum;
(function (DataTransferDestinationStatusEnum) {
    DataTransferDestinationStatusEnum["Accepted"] = "ACCEPTED";
    DataTransferDestinationStatusEnum["Available"] = "AVAILABLE";
    DataTransferDestinationStatusEnum["Deleted"] = "DELETED";
    DataTransferDestinationStatusEnum["DeletedByDestination"] = "DELETED_BY_DESTINATION";
    DataTransferDestinationStatusEnum["Expired"] = "EXPIRED";
    DataTransferDestinationStatusEnum["Rejected"] = "REJECTED";
    DataTransferDestinationStatusEnum["Retry"] = "RETRY";
    DataTransferDestinationStatusEnum["Transferring"] = "TRANSFERRING";
})(DataTransferDestinationStatusEnum || (DataTransferDestinationStatusEnum = {}));
var DataTransferStatusEnum;
(function (DataTransferStatusEnum) {
    DataTransferStatusEnum["Done"] = "DONE";
    DataTransferStatusEnum["Error"] = "ERROR";
    DataTransferStatusEnum["Preparing"] = "PREPARING";
    DataTransferStatusEnum["Transferring"] = "TRANSFERRING";
    DataTransferStatusEnum["Updating"] = "UPDATING";
})(DataTransferStatusEnum || (DataTransferStatusEnum = {}));
var DataTransferTypeEnum;
(function (DataTransferTypeEnum) {
    DataTransferTypeEnum["Exercise"] = "EXERCISE";
    DataTransferTypeEnum["GameTactic"] = "GAME_TACTIC";
    DataTransferTypeEnum["TrainingSession"] = "TRAINING_SESSION";
    DataTransferTypeEnum["Video"] = "VIDEO";
})(DataTransferTypeEnum || (DataTransferTypeEnum = {}));
var DiscountCodeStatusEnum;
(function (DiscountCodeStatusEnum) {
    DiscountCodeStatusEnum["Active"] = "ACTIVE";
    DiscountCodeStatusEnum["Inactive"] = "INACTIVE";
    DiscountCodeStatusEnum["Expired"] = "EXPIRED";
    DiscountCodeStatusEnum["Upcoming"] = "UPCOMING";
})(DiscountCodeStatusEnum || (DiscountCodeStatusEnum = {}));
var DiscountCodeTypeEnum;
(function (DiscountCodeTypeEnum) {
    DiscountCodeTypeEnum["FirstYear"] = "FIRST_YEAR";
    DiscountCodeTypeEnum["Contract"] = "CONTRACT";
})(DiscountCodeTypeEnum || (DiscountCodeTypeEnum = {}));
var DiscountTypeEnum;
(function (DiscountTypeEnum) {
    DiscountTypeEnum["Percentage"] = "PERCENTAGE";
    DiscountTypeEnum["Set"] = "SET";
})(DiscountTypeEnum || (DiscountTypeEnum = {}));
var ErrorMessageEnum;
(function (ErrorMessageEnum) {
    ErrorMessageEnum["ActivationProcessShouldAlreadyBeInitiated"] = "ACTIVATION_PROCESS_SHOULD_ALREADY_BE_INITIATED";
    ErrorMessageEnum["ActivationTokenExpired"] = "ACTIVATION_TOKEN_EXPIRED";
    ErrorMessageEnum["ForgotPasswordTokenIsExpired"] = "FORGOT_PASSWORD_TOKEN_IS_EXPIRED";
    ErrorMessageEnum["PlatformNotFound"] = "PLATFORM_NOT_FOUND";
    ErrorMessageEnum["SomethingWentWrong"] = "SOMETHING_WENT_WRONG";
    ErrorMessageEnum["TooManyLoginAttempts"] = "TOO_MANY_LOGIN_ATTEMPTS";
    ErrorMessageEnum["UserAlreadyActive"] = "USER_ALREADY_ACTIVE";
    ErrorMessageEnum["UserAlreadyVerified"] = "USER_ALREADY_VERIFIED";
    ErrorMessageEnum["UserNotFound"] = "USER_NOT_FOUND";
    ErrorMessageEnum["UserWithEmailNotExists"] = "USER_WITH_EMAIL_NOT_EXISTS";
    ErrorMessageEnum["UserWithEmailAlreadyExists"] = "USER_WITH_EMAIL_ALREADY_EXISTS";
    ErrorMessageEnum["PlatformIsNotATrialPlatform"] = "PLATFORM_IS_NOT_A_TRIAL_PLATFORM";
})(ErrorMessageEnum || (ErrorMessageEnum = {}));
var GameEventSubtypeEnum;
(function (GameEventSubtypeEnum) {
    GameEventSubtypeEnum["EnterField"] = "ENTER_FIELD";
    GameEventSubtypeEnum["LeaveField"] = "LEAVE_FIELD";
})(GameEventSubtypeEnum || (GameEventSubtypeEnum = {}));
var GameEventTypeEnum;
(function (GameEventTypeEnum) {
    GameEventTypeEnum["Goal"] = "GOAL";
    GameEventTypeEnum["OwnGoal"] = "OWN_GOAL";
    GameEventTypeEnum["PenaltyFailedMiss"] = "PENALTY_FAILED_MISS";
    GameEventTypeEnum["PenaltyFailedSave"] = "PENALTY_FAILED_SAVE";
    GameEventTypeEnum["Penalty"] = "PENALTY";
    GameEventTypeEnum["Red"] = "RED";
    GameEventTypeEnum["SecondYellow"] = "SECOND_YELLOW";
    GameEventTypeEnum["SixMeters"] = "SIX_METERS";
    GameEventTypeEnum["Substitution"] = "SUBSTITUTION";
    GameEventTypeEnum["TenMeters"] = "TEN_METERS";
    GameEventTypeEnum["Yellow"] = "YELLOW";
})(GameEventTypeEnum || (GameEventTypeEnum = {}));
var GameOfficialRoleEnum;
(function (GameOfficialRoleEnum) {
    GameOfficialRoleEnum["FirstAssistant"] = "FIRST_ASSISTANT";
    GameOfficialRoleEnum["SecondAssistant"] = "SECOND_ASSISTANT";
    GameOfficialRoleEnum["Referee"] = "REFEREE";
    GameOfficialRoleEnum["FourthOfficial"] = "FOURTH_OFFICIAL";
})(GameOfficialRoleEnum || (GameOfficialRoleEnum = {}));
var GameStatusEnum;
(function (GameStatusEnum) {
    GameStatusEnum["Cancelled"] = "CANCELLED";
    GameStatusEnum["Finished"] = "FINISHED";
    GameStatusEnum["Forfeit"] = "FORFEIT";
    GameStatusEnum["GeneralForfeit"] = "GENERAL_FORFEIT";
    GameStatusEnum["Planned"] = "PLANNED";
    GameStatusEnum["Postponed"] = "POSTPONED";
    GameStatusEnum["Stopped"] = "STOPPED";
    GameStatusEnum["Deleted"] = "DELETED";
})(GameStatusEnum || (GameStatusEnum = {}));
var GenderTypeEnum;
(function (GenderTypeEnum) {
    GenderTypeEnum["Female"] = "FEMALE";
    GenderTypeEnum["Male"] = "MALE";
})(GenderTypeEnum || (GenderTypeEnum = {}));
var LanguageEnum;
(function (LanguageEnum) {
    LanguageEnum["En"] = "EN";
    LanguageEnum["Nl"] = "NL";
    LanguageEnum["Fr"] = "FR";
    LanguageEnum["Ja"] = "JA";
    LanguageEnum["Kr"] = "KR";
    LanguageEnum["Cn"] = "CN";
    LanguageEnum["Es"] = "ES";
    LanguageEnum["De"] = "DE";
    LanguageEnum["Ko"] = "KO";
    LanguageEnum["Zh"] = "ZH";
    LanguageEnum["El"] = "EL";
    LanguageEnum["Fi"] = "FI";
    LanguageEnum["Cs"] = "CS";
    LanguageEnum["It"] = "IT";
    LanguageEnum["Lt"] = "LT";
    LanguageEnum["Pt"] = "PT";
    LanguageEnum["Sk"] = "SK";
    LanguageEnum["Sl"] = "SL";
    LanguageEnum["Ro"] = "RO";
})(LanguageEnum || (LanguageEnum = {}));
var LogoSizeEnum;
(function (LogoSizeEnum) {
    LogoSizeEnum["S"] = "s";
    LogoSizeEnum["M"] = "m";
    LogoSizeEnum["L"] = "l";
    LogoSizeEnum["Xl"] = "xl";
    LogoSizeEnum["Xxl"] = "xxl";
})(LogoSizeEnum || (LogoSizeEnum = {}));
var MemberStatusEnum;
(function (MemberStatusEnum) {
    MemberStatusEnum["All"] = "ALL";
    MemberStatusEnum["Player"] = "PLAYER";
    MemberStatusEnum["Staff"] = "STAFF";
})(MemberStatusEnum || (MemberStatusEnum = {}));
var MergeStatusEnum;
(function (MergeStatusEnum) {
    MergeStatusEnum["Done"] = "DONE";
    MergeStatusEnum["Merging"] = "MERGING";
    MergeStatusEnum["Invalid"] = "INVALID";
})(MergeStatusEnum || (MergeStatusEnum = {}));
var OnboardingStepEnum;
(function (OnboardingStepEnum) {
    OnboardingStepEnum["TeamsAndMembers"] = "TEAMS_AND_MEMBERS";
    OnboardingStepEnum["Resources"] = "RESOURCES";
    OnboardingStepEnum["StartPlanning"] = "START_PLANNING";
    OnboardingStepEnum["OnboardUser"] = "ONBOARD_USER";
})(OnboardingStepEnum || (OnboardingStepEnum = {}));
var OnboardingTaskEnum;
(function (OnboardingTaskEnum) {
    OnboardingTaskEnum["CreateLocation"] = "CREATE_LOCATION";
    OnboardingTaskEnum["CreatePlayingField"] = "CREATE_PLAYING_FIELD";
    OnboardingTaskEnum["CreateDressingRoom"] = "CREATE_DRESSING_ROOM";
    OnboardingTaskEnum["CreateMeetingPlace"] = "CREATE_MEETING_PLACE";
    OnboardingTaskEnum["CreateTeam"] = "CREATE_TEAM";
    OnboardingTaskEnum["FivePlayers"] = "FIVE_PLAYERS";
    OnboardingTaskEnum["TwoStaff"] = "TWO_STAFF";
    OnboardingTaskEnum["AddTraining"] = "ADD_TRAINING";
    OnboardingTaskEnum["AddActivity"] = "ADD_ACTIVITY";
    OnboardingTaskEnum["AddGame"] = "ADD_GAME";
    OnboardingTaskEnum["InviteStaff"] = "INVITE_STAFF";
    OnboardingTaskEnum["InvitePlayers"] = "INVITE_PLAYERS";
})(OnboardingTaskEnum || (OnboardingTaskEnum = {}));
var PlatformComponentType;
(function (PlatformComponentType) {
    PlatformComponentType["Module"] = "MODULE";
    PlatformComponentType["Package"] = "PACKAGE";
    PlatformComponentType["VideoPlan"] = "VIDEO_PLAN";
})(PlatformComponentType || (PlatformComponentType = {}));
var PlatformDataConnectionTypeEnum;
(function (PlatformDataConnectionTypeEnum) {
    PlatformDataConnectionTypeEnum["Game"] = "GAME";
    PlatformDataConnectionTypeEnum["MemberRequest"] = "MEMBER_REQUEST";
    PlatformDataConnectionTypeEnum["Player"] = "PLAYER";
    PlatformDataConnectionTypeEnum["Scouting"] = "SCOUTING";
    PlatformDataConnectionTypeEnum["Team"] = "TEAM";
    PlatformDataConnectionTypeEnum["TeamCompetition"] = "TEAM_COMPETITION";
})(PlatformDataConnectionTypeEnum || (PlatformDataConnectionTypeEnum = {}));
var PlatformStatusEnum;
(function (PlatformStatusEnum) {
    PlatformStatusEnum["Success"] = "SUCCESS";
    PlatformStatusEnum["Processing"] = "PROCESSING";
    PlatformStatusEnum["Error"] = "ERROR";
    PlatformStatusEnum["UpdateError"] = "UPDATE_ERROR";
})(PlatformStatusEnum || (PlatformStatusEnum = {}));
var ReportingDataSetTypeEnum;
(function (ReportingDataSetTypeEnum) {
    ReportingDataSetTypeEnum["Live"] = "LIVE";
    ReportingDataSetTypeEnum["Aggregated"] = "AGGREGATED";
})(ReportingDataSetTypeEnum || (ReportingDataSetTypeEnum = {}));
var ReportingDatasetColumnTypeEnum;
(function (ReportingDatasetColumnTypeEnum) {
    ReportingDatasetColumnTypeEnum["Hierarchy"] = "HIERARCHY";
    ReportingDatasetColumnTypeEnum["Numeric"] = "NUMERIC";
    ReportingDatasetColumnTypeEnum["Datetime"] = "DATETIME";
})(ReportingDatasetColumnTypeEnum || (ReportingDatasetColumnTypeEnum = {}));
var ReportingParamTypeEnum;
(function (ReportingParamTypeEnum) {
    ReportingParamTypeEnum["Datetime"] = "DATETIME";
    ReportingParamTypeEnum["Hierarchy"] = "HIERARCHY";
    ReportingParamTypeEnum["HierarchyArray"] = "HIERARCHY_ARRAY";
    ReportingParamTypeEnum["Numeric"] = "NUMERIC";
    ReportingParamTypeEnum["NumericArray"] = "NUMERIC_ARRAY";
})(ReportingParamTypeEnum || (ReportingParamTypeEnum = {}));
var ScopeEnum;
(function (ScopeEnum) {
    ScopeEnum["Clubs"] = "CLUBS";
    ScopeEnum["Operations"] = "OPERATIONS";
    ScopeEnum["Platforms"] = "PLATFORMS";
    ScopeEnum["Reports"] = "REPORTS";
    ScopeEnum["Sportive"] = "SPORTIVE";
    ScopeEnum["Tasks"] = "TASKS";
    ScopeEnum["Users"] = "USERS";
})(ScopeEnum || (ScopeEnum = {}));
var SportsTypeEnum;
(function (SportsTypeEnum) {
    SportsTypeEnum["Futsal"] = "FUTSAL";
    SportsTypeEnum["Hockey"] = "HOCKEY";
    SportsTypeEnum["Soccer"] = "SOCCER";
    SportsTypeEnum["Tennis"] = "TENNIS";
    SportsTypeEnum["Volley"] = "VOLLEY";
})(SportsTypeEnum || (SportsTypeEnum = {}));
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["Valid"] = "VALID";
    StatusEnum["Pending"] = "PENDING";
    StatusEnum["Invalid"] = "INVALID";
    StatusEnum["Inactive"] = "INACTIVE";
    StatusEnum["Merging"] = "MERGING";
})(StatusEnum || (StatusEnum = {}));
var StreamLogStatusEnum;
(function (StreamLogStatusEnum) {
    StreamLogStatusEnum["Created"] = "CREATED";
    StreamLogStatusEnum["Done"] = "DONE";
    StreamLogStatusEnum["Error"] = "ERROR";
    StreamLogStatusEnum["MarkResolved"] = "MARK_RESOLVED";
    StreamLogStatusEnum["Processing"] = "PROCESSING";
    StreamLogStatusEnum["ProcessingInterrupted"] = "PROCESSING_INTERRUPTED";
    StreamLogStatusEnum["Reprocessed"] = "REPROCESSED";
})(StreamLogStatusEnum || (StreamLogStatusEnum = {}));
var TeamOfficialRoleEnum;
(function (TeamOfficialRoleEnum) {
    TeamOfficialRoleEnum["AssistantCoach"] = "ASSISTANT_COACH";
    TeamOfficialRoleEnum["Coach"] = "COACH";
    TeamOfficialRoleEnum["Director"] = "DIRECTOR";
    TeamOfficialRoleEnum["GoalkeeperCoach"] = "GOALKEEPER_COACH";
    TeamOfficialRoleEnum["Other"] = "OTHER";
    TeamOfficialRoleEnum["PhysicalTrainer"] = "PHYSICAL_TRAINER";
    TeamOfficialRoleEnum["Physiotherapist"] = "PHYSIOTHERAPIST";
    TeamOfficialRoleEnum["TeamDoctor"] = "TEAM_DOCTOR";
})(TeamOfficialRoleEnum || (TeamOfficialRoleEnum = {}));

class TrialPlatformDTO {
    constructor() {
        this.sportsType = SportsTypeEnum.Soccer;
    }
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.club) {
            this.club = new Club().deserialize(json.club);
        }
        if (json.platformPackage) {
            this.platformPackage = new PlatformPackage().deserialize(json.club);
        }
        this.addOns = deserializeList(json.addOns, function (item) {
            return new Module().deserialize(item);
        });
        return this;
    }
}

class UserDTO {
    constructor() {
        this.trialPlatformCreated = true;
    }
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class PaymentSessionCreate {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class PSDTranslateLoader {
    constructor(translationService) {
        this.translationService = translationService;
    }
    /**
     * Gets the translations from the server
     * @param lang
     * @returns {any}
     */
    getTranslation(lang) {
        return this.translationService.getTranslations(lang);
    }
}

class Toaster {
    constructor(toasterService) {
        this.toasterService = toasterService;
    }
    error(title, msg) {
        this.toast('error', title, msg);
    }
    success(title, msg) {
        this.toast('success', title, msg);
    }
    warning(title, msg) {
        this.toast('warning', title, msg);
    }
    toast(type, title, msg) {
        this.toasterService.pop(type, title, msg);
    }
}
Toaster.ɵfac = function Toaster_Factory(t) { return new (t || Toaster)(ɵɵinject(ToasterService)); };
Toaster.ɵprov = ɵɵdefineInjectable({ token: Toaster, factory: Toaster.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(Toaster, [{
        type: Injectable
    }], function () { return [{ type: ToasterService }]; }, null); })();

class CookieUtil {
    static setCentralCookies(centralAccessToken, centralRefreshToken, prod, expiresIn) {
        let domain = document.domain.split('.').reverse().splice(0, 2).reverse().join('.');
        if (!expiresIn) {
            expiresIn = 3600;
        }
        if (prod) {
            document.cookie = 'central_access_token=' + centralAccessToken + ';max-age=' + expiresIn + ';path=/;domain=' + domain + ';samesite=lax;secure;';
            document.cookie = 'central_refresh_token=' + centralRefreshToken + ';max-age=2592000;path=/;domain=' + domain + ';samesite=lax;secure;';
        }
        else {
            document.cookie = 'central_access_token_dev=' + centralAccessToken + ';max-age=' + expiresIn + ';path=/;domain=' + domain + ';samesite=lax;';
            document.cookie = 'central_refresh_token_dev=' + centralRefreshToken + ';max-age=2592000;path=/;domain=' + domain + ';samesite=lax;';
        }
    }
}

function PasswordStrengthValidator() {
    return (control) => {
        const value = control.value;
        let format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if (!value.match(/\d/) || !value.match(/[A-Z]/) || !format.test(value)) {
            return { passwordStrength: true };
        }
        else {
            return null;
        }
    };
}

class PusherUtil {
    static getPusher() {
        if (PusherUtil.pusher == null) {
            PusherUtil.pusher = new Pusher('916bfbe1225b2e9f2583', {
                "authEndpoint": '/pusher_auth.php'
            });
        }
        return PusherUtil.pusher;
    }
    static updatePusherAuthorization() {
        PusherUtil.pusher = null;
    }
}

class ErrorUtil {
    static showError(msg, showCloseBtn = true) {
        let translateService = APP_INJECTOR.get(TranslateService);
        setTimeout(function () {
            // the translations have been loaded
            /*if (translateService.instant('button.close') != 'button.close') {
              let errorModal:any = $('<div class="modal general-error fade" role="dialog" aria-hidden="true" style="display: none;">' +
                '<div class="vertical-alignment-helper"> ' +
                '<div class="modal-dialog vertical-align-center">' +
                '<div class="modal-content panel-warning">' +
                '<div class="modal-header text-center">' +
                '<h4 class="modal-title">' + translateService.instant('error.general.unexpected') + '</h4>' +
                '</div>' +
                '<div class="modal-body">' +
                translateService.instant('error.general.unexpected.intro') +
                '<br/><br/>' +
                '<pre>' +
                msg +
                '</pre>' +
                '</div>' +
                '<div class="modal-footer">' +
                '<div class="row">' +
                '<div class="col-md-6 col-md-offset-3 text-center">' +
                (showCloseBtn ? '<button type="button" class="btn btn-block btn-default" onclick="$(\'.general-error\').modal(\'hide\')" style="width: 100%;">' + translateService.instant('button.close') + '</button>' : '') +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>');
      
              $('body').append(errorModal);
              errorModal.modal('show');
            } else {
              ErrorUtil.showError(msg);
            }*/
        }, 250);
    }
    static showLoggedOut() {
        /*let translateService:TranslateService = APP_INJECTOR.get(TranslateService);
    
        let infoModal:any = $('<div class="modal general-error fade" role="dialog" aria-hidden="true" style="display: none;">' +
          '<div class="vertical-alignment-helper"> ' +
          '<div class="modal-dialog vertical-align-center">' +
          '<div class="modal-content panel-warning">' +
          '<div class="modal-header text-center">' +
          '<h4 class="modal-title">' + translateService.instant('error.session.expired') + '</h4>' +
          '</div>' +
          '<div class="modal-body">' +
          translateService.instant('error.session.expired.intro') +
          '</div>' +
          '<div class="modal-footer">' +
          '<div class="row">' +
          '<div class="col-md-6 col-md-offset-3 text-center">' +
          '<button type="button" class="btn btn-block btn-default" onclick="document.location.href=\'/\';" style="width: 100%;">' + translateService.instant('button.relogin') + '</button>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</div>');
    
        $('body').append(infoModal);
        infoModal.modal('show');*/
    }
}

class CookieService {
    constructor(document, 
    // Get the `PLATFORM_ID` so we can check if we're in a browser.
    platformId) {
        this.document = document;
        this.platformId = platformId;
        this.documentIsAccessible = isPlatformBrowser(this.platformId);
    }
    /**
     * Get cookie Regular Expression
     *
     * @param name Cookie name
     * @returns property RegExp
     *
     * @author: Stepan Suvorov
     * @since: 1.0.0
     */
    static getCookieRegExp(name) {
        const escapedName = name.replace(/([\[\]\{\}\(\)\|\=\;\+\?\,\.\*\^\$])/gi, '\\$1');
        return new RegExp('(?:^' + escapedName + '|;\\s*' + escapedName + ')=(.*?)(?:;|$)', 'g');
    }
    /**
     * Gets the unencoded version of an encoded component of a Uniform Resource Identifier (URI).
     *
     * @param encodedURIComponent A value representing an encoded URI component.
     *
     * @returns The unencoded version of an encoded component of a Uniform Resource Identifier (URI).
     *
     * @author: Stepan Suvorov
     * @since: 1.0.0
     */
    static safeDecodeURIComponent(encodedURIComponent) {
        try {
            return decodeURIComponent(encodedURIComponent);
        }
        catch (_a) {
            // probably it is not uri encoded. return as is
            return encodedURIComponent;
        }
    }
    /**
     * Return `true` if {@link Document} is accessible, otherwise return `false`
     *
     * @param name Cookie name
     * @returns boolean - whether cookie with specified name exists
     *
     * @author: Stepan Suvorov
     * @since: 1.0.0
     */
    check(name) {
        if (!this.documentIsAccessible) {
            return false;
        }
        name = encodeURIComponent(name);
        const regExp = CookieService.getCookieRegExp(name);
        return regExp.test(this.document.cookie);
    }
    /**
     * Get cookies by name
     *
     * @param name Cookie name
     * @returns property value
     *
     * @author: Stepan Suvorov
     * @since: 1.0.0
     */
    get(name) {
        if (this.documentIsAccessible && this.check(name)) {
            name = encodeURIComponent(name);
            const regExp = CookieService.getCookieRegExp(name);
            const result = regExp.exec(this.document.cookie);
            return result[1] ? CookieService.safeDecodeURIComponent(result[1]) : '';
        }
        else {
            return '';
        }
    }
    /**
     * Get central cookies by name
     *
     * @param name Cookie name
     * @returns property value
     *
     * @author: Robin Vinck
     * @since: 1.0.0
     */
    getCentralCookie(_name, prod) {
        const cookieName = prod ? _name : _name + '_dev';
        if (this.documentIsAccessible && this.check(cookieName)) {
            const name = encodeURIComponent(cookieName);
            const regExp = CookieService.getCookieRegExp(name);
            const result = regExp.exec(this.document.cookie);
            return result != null ? CookieService.safeDecodeURIComponent(result[1]) : '';
        }
        else {
            return '';
        }
    }
    /**
     * Get all cookies in JSON format
     *
     * @returns all the cookies in json
     *
     * @author: Stepan Suvorov
     * @since: 1.0.0
     */
    getAll() {
        if (!this.documentIsAccessible) {
            return {};
        }
        const cookies = {};
        const document = this.document;
        if (document.cookie && document.cookie !== '') {
            document.cookie.split(';').forEach((currentCookie) => {
                const [cookieName, cookieValue] = currentCookie.split('=');
                cookies[CookieService.safeDecodeURIComponent(cookieName.replace(/^ /, ''))] = CookieService.safeDecodeURIComponent(cookieValue);
            });
        }
        return cookies;
    }
    set(name, value, expiresOrOptions, path, domain, secure, sameSite) {
        if (!this.documentIsAccessible) {
            return;
        }
        if (typeof expiresOrOptions === 'number' || expiresOrOptions instanceof Date || path || domain || secure || sameSite) {
            const optionsBody = {
                expires: expiresOrOptions,
                path,
                domain,
                secure,
                sameSite: sameSite ? sameSite : 'Lax',
            };
            this.set(name, value, optionsBody);
            return;
        }
        let cookieString = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';';
        const options = expiresOrOptions ? expiresOrOptions : {};
        if (options.expires) {
            if (typeof options.expires === 'number') {
                const dateExpires = new Date(new Date().getTime() + options.expires * 1000 * 60 * 60 * 24);
                cookieString += 'expires=' + dateExpires.toUTCString() + ';';
            }
            else {
                cookieString += 'expires=' + options.expires.toUTCString() + ';';
            }
        }
        if (options.path) {
            cookieString += 'path=' + options.path + ';';
        }
        if (options.domain) {
            cookieString += 'domain=' + options.domain + ';';
        }
        if (options.secure === false && options.sameSite === 'None') {
            options.secure = true;
            console.warn(`[ngx-cookie-service] Cookie ${name} was forced with secure flag because sameSite=None.` +
                `More details : https://github.com/stevermeister/ngx-cookie-service/issues/86#issuecomment-597720130`);
        }
        if (options.secure) {
            cookieString += 'secure;';
        }
        if (!options.sameSite) {
            options.sameSite = 'Lax';
        }
        cookieString += 'sameSite=' + options.sameSite + ';';
        this.document.cookie = cookieString;
    }
    /**
     * Delete cookie by name
     *
     * @param name   Cookie name
     * @param path   Cookie path
     * @param domain Cookie domain
     * @param secure Cookie secure flag
     * @param sameSite Cookie sameSite flag - https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
     *
     * @author: Stepan Suvorov
     * @since: 1.0.0
     */
    delete(name, path, domain, secure, sameSite = 'Lax') {
        if (!this.documentIsAccessible) {
            return;
        }
        const expiresDate = new Date('Thu, 01 Jan 1970 00:00:01 GMT');
        this.set(name, '', { expires: expiresDate, path, domain, secure, sameSite });
    }
    /**
     * Delete central cookie by name
     *
     * @param name   Cookie name
     * @param path   Cookie path
     * @param domain Cookie domain
     * @param secure Cookie secure flag
     * @param sameSite Cookie sameSite flag - https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
     *
     * @author: Robin Vinck
     * @since: 1.0.0
     */
    deleteCentralCookie(_name, prod, path, domain, secure, sameSite = 'Lax') {
        const name = prod ? _name : _name + '_dev';
        if (!this.documentIsAccessible) {
            return;
        }
        const expiresDate = new Date('Thu, 01 Jan 1970 00:00:01 GMT');
        this.set(name, '', { expires: expiresDate, path, domain, secure, sameSite });
    }
    /**
     * Delete all cookies
     *
     * @param path   Cookie path
     * @param domain Cookie domain
     * @param secure Is the Cookie secure
     * @param sameSite Is the cookie same site
     *
     * @author: Stepan Suvorov
     * @since: 1.0.0
     */
    deleteAll(path, domain, secure, sameSite = 'Lax') {
        if (!this.documentIsAccessible) {
            return;
        }
        const cookies = this.getAll();
        for (const cookieName in cookies) {
            if (cookies.hasOwnProperty(cookieName)) {
                this.delete(cookieName, path, domain, secure, sameSite);
            }
        }
    }
}
CookieService.ɵfac = function CookieService_Factory(t) { return new (t || CookieService)(ɵɵinject(DOCUMENT), ɵɵinject(PLATFORM_ID)); };
CookieService.ɵprov = ɵɵdefineInjectable({ token: CookieService, factory: CookieService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CookieService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

var Action;
(function (Action) {
    Action[Action["QueryStart"] = 0] = "QueryStart";
    Action[Action["QueryStop"] = 1] = "QueryStop";
})(Action || (Action = {}));
class HttpAuthentication {
    constructor(_http, cookieService) {
        this._http = _http;
        this.cookieService = cookieService;
        this.process = new EventEmitter();
        this.authFailed = new EventEmitter();
        this.portNumber = 8090;
        this.refreshingToken = false;
        this.numberRetries = 0;
    }
    getBaseUrl() {
        return localStorage.getItem('apiBaseURL') != null ? localStorage.getItem('apiBaseURL') : '';
    }
    get(url, pageRequest, responseType, originalAccessToken = false, centralAccessToken, baseUrl) {
        return this._request('GET', null, url, null, pageRequest, responseType, centralAccessToken, originalAccessToken, baseUrl);
    }
    post(url, body, responseType, originalAccessToken = false, pageRequest, centralAccessToken, baseUrl) {
        return this._request(null, 'POST', url, body, pageRequest, responseType, centralAccessToken, originalAccessToken, baseUrl);
    }
    put(url, body, originalAccessToken = false, centralAccessToken) {
        return this._request(null, 'PUT', url, body, null, null, centralAccessToken, originalAccessToken);
    }
    delete(url, originalAccessToken = false, centralAccessToken) {
        return this._request('DELETE', null, url, null, null, null, centralAccessToken);
    }
    head(url) {
        return this._request('HEAD', null, url, null);
    }
    postWithFile(url, file, postData, progressFn, includeBaseURL = true) {
        return Observable.create(observer => {
            let formData = new FormData(), xhr = new XMLHttpRequest();
            if (postData != null) {
                for (let prop in postData) {
                    if (postData.hasOwnProperty(prop)) {
                        formData.append(prop, postData[prop]);
                    }
                }
            }
            formData.append('file', file, file.name);
            if (progressFn != null) {
                xhr.upload.onprogress = evt => {
                    if (evt.lengthComputable) {
                        progressFn((evt.loaded / evt.total) * 100);
                    }
                    else {
                        progressFn(-1);
                    }
                };
            }
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        observer.next(JSON.parse(xhr.response));
                        observer.complete();
                    }
                    else {
                        observer.error(xhr.response);
                    }
                }
            };
            if (includeBaseURL) {
                xhr.open('POST', this.getBaseUrl() + url, true);
            }
            else {
                xhr.open('POST', url, true);
            }
            xhr.send(formData);
        });
    }
    _request(getMethod, postMethod, url, body, pageRequest, responseType, centralAccessToken, originalAccessToken = false, baseUrl) {
        let params = null;
        if (pageRequest != null) {
            params = new HttpParams();
            params = params.append('size', String(pageRequest.count));
            params = params.append('page', String(pageRequest.firstResult));
            if (pageRequest.orderBy != null) {
                for (let sort of pageRequest.orderBy) {
                    params = params.append('sort', sort.property + ',' + sort.direction);
                }
            }
        }
        let request;
        let headers = new HttpHeaders();
        let requestMethod;
        let requestStartTime = new Date().getTime();
        headers = headers.append('Accept-Language', UserUtil.getUserLanguage());
        headers = headers.append('ClientTimeZone', moment.tz.guess());
        headers = headers.append('X-start-timestamp', String(requestStartTime));
        if (centralAccessToken) {
            headers = headers.append('Central-Token', centralAccessToken);
        }
        if (postMethod != null) {
            headers = headers.append('Content-Type', 'application/json');
        }
        if (getMethod != null) {
            requestMethod = getMethod;
            request = new HttpRequest(getMethod, (url != '/refresh_token.php' ? (baseUrl != null ? baseUrl : this.getBaseUrl()) : '') + url, {
                headers: headers,
                params: params,
                responseType: responseType != null ? responseType : 'json',
                withCredentials: true
            });
        }
        else if (postMethod != null) {
            requestMethod = postMethod;
            request = new HttpRequest(postMethod, (url != '/refresh_token.php' ? (baseUrl != null ? baseUrl : this.getBaseUrl()) : '') + url, body, {
                headers: headers,
                params: params,
                responseType: responseType != null ? responseType : 'json',
                withCredentials: true
            });
        }
        return Observable.create(observer => {
            this.process.next(Action.QueryStart);
            this._http.request(request).subscribe(res => {
                let result = res;
                switch (result.status) {
                    case NO_CONTENT:
                        //  when object was not found, the API returns empty response with a 204 status code (object not found)
                        //  if this is the case, we return an error to the component
                        observer.error(result);
                        break;
                    case OK:
                        observer.next(result);
                        observer.complete();
                        break;
                }
            }, err => {
                let error = new ApiError();
                let msg;
                switch (err.status) {
                    case NOT_FOUND:
                    case FORBIDDEN:
                    case CONFLICT:
                    case INTERNAL_SERVER_ERROR:
                        error = new ApiError().deserialize(err.error);
                        msg = error.message;
                        if (msg != null) {
                            ErrorUtil.showError(msg);
                        }
                        observer.error(error);
                        break;
                    case BAD_REQUEST:
                        error = new ApiError().deserialize(err.error);
                        if (error.subErrors != null && error.subErrors.every(subError => subError instanceof ApiValidationError)) {
                            observer.error(error);
                            break;
                        }
                        else {
                            msg = error.message;
                            if (msg != null) {
                                ErrorUtil.showError(msg);
                            }
                            observer.error(err);
                            break;
                        }
                    default:
                        /*if(request.url.indexOf('/oauth/token') == -1) {
                          let me = this;
                          me.refreshToken(request, observer, environment);
                          break;
                        } else {
                             observer.error(err);
                        } */
                        observer.error(err);
                }
            });
        });
    }
    // todo: check if we are trying to execute a public app API call (=central access token available), if so => refresh the central tokens
    //  if not => we need to refresh the platform tokens...
    refreshToken(requestOptions, observer, _environment, afterTimeout = false) {
        let me = this;
        if (this.refreshingToken) {
            let randomTimeout = Math.floor(Math.random() * 500) + 100;
            setTimeout(() => {
                me.refreshToken(requestOptions, observer, _environment, true);
            }, randomTimeout);
        }
        else {
            if (afterTimeout) {
                let headers = requestOptions.headers;
                me._http.request(requestOptions.clone({ headers })).subscribe(res => {
                    observer.next(res);
                    observer.complete();
                }, err => {
                    observer.error(err);
                });
            }
            else {
                this.refreshingToken = true;
                const apiPath = localStorage.getItem('apiBaseURL');
                const httpOptions = {
                    headers: new HttpHeaders({
                        'Authorization': 'Basic ' + btoa(_environment.APIUsername + ':' + _environment.APIPassword),
                        'Content-Type': 'application/x-www-form-urlencoded'
                    })
                };
                let bodyReq = {
                    type: 'login',
                    refresh_token: this.cookieService.get('refresh_token'),
                    grant_type: 'refresh_token'
                };
                this._http.post(apiPath + '/oauth/token?type=login&refresh_token=' + this.cookieService.get('refresh_token') + '&grant_type=refresh_token', {}, httpOptions).subscribe(result => {
                    me.refreshingToken = false;
                    if (result.access_token != null && result.access_token != '') {
                        me.numberRetries = 0;
                        // refresh pusher authorization
                        PusherUtil.updatePusherAuthorization();
                        let headers = requestOptions.headers;
                        me._http.request(requestOptions.clone({ headers })).subscribe(res => {
                            let bubbledResult = res;
                            switch (bubbledResult.status) {
                                case 204:
                                    //  when object was not found, the API returns empty response with a 204 status code (object not found)
                                    //  if this is the case, we return an error to the component
                                    observer.error(bubbledResult);
                                    break;
                                case 200:
                                    observer.next(bubbledResult);
                                    observer.complete();
                                    break;
                            }
                        }, err => {
                            observer.error(err);
                        });
                    }
                    else {
                        document.location.href = '/index.php?p=logout'; // cookies are being removed in the index.php
                    }
                }, error => {
                    if (error.status != 0) {
                        setTimeout(function () {
                            window.location.reload();
                        }, 10000);
                    }
                    else {
                        me.refreshingToken = false;
                    }
                });
            }
        }
    }
}
HttpAuthentication.ɵfac = function HttpAuthentication_Factory(t) { return new (t || HttpAuthentication)(ɵɵinject(HttpClient), ɵɵinject(CookieService)); };
HttpAuthentication.ɵprov = ɵɵdefineInjectable({ token: HttpAuthentication, factory: HttpAuthentication.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HttpAuthentication, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: CookieService }]; }, null); })();

class URLParams {
    constructor() {
    }
    get(name) {
        let param = new HttpParams({ fromString: window.location.href.replace('?', '?&') }).get(name);
        if (param != null && param.indexOf('#') >= 0) {
            param = param.substr(0, param.indexOf('#'));
        }
        return param;
    }
    getNumber(name) {
        let paramValue = this.get(name);
        if (paramValue) {
            return Number(paramValue);
        }
        else {
            return null;
        }
    }
    setUrl(url) {
        if (history.pushState) {
            history.pushState(null, null, '?' + url);
        }
    }
    setHash(hashValue) {
        if (history.pushState) {
            history.pushState(null, null, '#' + hashValue);
        }
        else {
            location.hash = '#' + hashValue;
        }
    }
}
URLParams.ɵfac = function URLParams_Factory(t) { return new (t || URLParams)(); };
URLParams.ɵprov = ɵɵdefineInjectable({ token: URLParams, factory: URLParams.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(URLParams, [{
        type: Injectable
    }], function () { return []; }, null); })();

class User {
    constructor() {
        this.acceptedTermsOfUse = false;
        this.spoc = false;
        this.globalPSDAdmin = false;
        this.showProductTours = false;
    }
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.member != null) {
            this.member = new Member().deserialize(json.member);
        }
        this.function = new UserProfile().deserialize(json.function);
        return this;
    }
    get player() {
        return this.member != null && this.member.player;
    }
    get staff() {
        return this.member != null && this.member.staff;
    }
    get fullName() {
        return this.member != null ? this.member.fullName : '';
    }
    get nameWithAdmin() {
        return (this.member != null ? this.member.fullName : '') + (this.function != null && this.function.id === 1 ? ' (Admin)' : '');
    }
}

class Cognito {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class CloudfrontPipe {
    constructor(configParamsService) {
        this.configParamsService = configParamsService;
    }
    transform(urlPath) {
        if (this.configParamsService.getConfigParam('cloudfront')) {
            return (this.configParamsService.getConfigParam('cloudfront') + urlPath).toString();
        }
        else {
            return urlPath.toString();
        }
    }
}
CloudfrontPipe.ɵfac = function CloudfrontPipe_Factory(t) { return new (t || CloudfrontPipe)(ɵɵdirectiveInject(ConfigParamsService)); };
CloudfrontPipe.ɵpipe = ɵɵdefinePipe({ name: "cloudfrontPipe", type: CloudfrontPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CloudfrontPipe, [{
        type: Pipe,
        args: [{
                name: 'cloudfrontPipe'
            }]
    }], function () { return [{ type: ConfigParamsService }]; }, null); })();

class CommonCacheService extends BaseService {
    constructor() {
        super();
        this.caches = {
            'translations': new Cache(CommonCacheService.CACHE_TRANSLATIONS, 1800, 3600, true),
            'country': new Cache(CommonCacheService.CACHE_COUNTRY, 3600, 86400, true, Country),
            'languages': new Cache(CommonCacheService.CACHE_LANGUAGES, 3600, 86400, true, Language)
        };
    }
    getCached(id, cacheName, requestIfNotInCache) {
        if (this.caches[cacheName] == null) {
            throw new Error('invalid cache name: ' + cacheName);
        }
        let cachedValue = this.getFromCache(id, cacheName);
        if (cachedValue != null) {
            return this.getAsObservable(cachedValue);
        }
        else {
            return Observable.create(observer => {
                requestIfNotInCache.subscribe(value => {
                    this.putInCache(id, value, cacheName);
                    observer.next(value);
                    observer.complete();
                });
            });
        }
    }
    getAsObservable(item) {
        return Observable.create(observer => {
            observer.next(item);
            observer.complete();
        });
    }
    clearCacheItem(id, cacheName) {
        let cache = this.caches[cacheName];
        cache.removeFromCache(id);
    }
    getFromCache(id, cacheName) {
        let cache = this.caches[cacheName];
        let cacheItem = null;
        let item = null;
        // don't use cache in local development environment
        if (!cache.localStorage || (cache.localStorage && localStorage.getItem('environment') != 'DEV')) {
            cacheItem = cache.getCacheItem(id);
            if (cacheItem != null) {
                let currentTime = new Date().getTime();
                if (cacheItem.creationDate + cache.timeToLiveSeconds * 1000 > currentTime) {
                    if (cacheItem.lastAccessDate + cache.timeToIdleSeconds * 1000 > currentTime) {
                        if (cache.localStorage) {
                            item = this.deserializeItem(cache, cacheItem);
                        }
                        else {
                            item = cacheItem.value;
                        }
                        cacheItem.lastAccessDate = currentTime;
                    }
                    else {
                        cache.removeFromCache(id);
                    }
                }
                else {
                    cache.removeFromCache(id);
                }
            }
        }
        return item;
    }
    putInCache(id, item, cacheName) {
        this.caches[cacheName].putCacheItem(id, item);
    }
    deserializeItem(cache, cacheItem) {
        let deserializedValue = cacheItem.value;
        if (cache.objectType != null) {
            let objectTypeClass = cache.objectType;
            if (cacheItem.array) {
                deserializedValue = deserializeList(cacheItem.value, function (item) {
                    return new objectTypeClass().deserialize(item);
                });
            }
            else {
                deserializedValue = new objectTypeClass().deserialize(cacheItem.value);
            }
        }
        return deserializedValue;
    }
}
CommonCacheService.CACHE_AGECATEGORY = 'agecategory';
CommonCacheService.CACHE_ABSENCEREASONS = 'absencereasons';
CommonCacheService.CACHE_ARBITRATION = 'arbitrations';
CommonCacheService.CACHE_CENTRALTEAM = 'centralteam';
CommonCacheService.CACHE_CERTIFICATE = 'certificate';
CommonCacheService.CACHE_CLOTHINGROOM = 'clothingroom';
CommonCacheService.CACHE_COMPETITIONTYPE = 'competitiontype';
CommonCacheService.CACHE_CONTRACT = 'contract';
CommonCacheService.CACHE_COUNTRY = 'country';
CommonCacheService.CACHE_FIELDOCCUPATION = 'fieldoccupation';
CommonCacheService.CACHE_FILTER = 'filter';
CommonCacheService.CACHE_GAMELEVEL = 'gamelevel';
CommonCacheService.CACHE_GAMEROUND = 'gameround';
CommonCacheService.CACHE_GAMETABLE = 'gametable';
CommonCacheService.CACHE_GAMESITE = 'gamesite';
CommonCacheService.CACHE_GROUPS = 'groups';
CommonCacheService.CACHE_LANGUAGES = 'languages';
CommonCacheService.CACHE_MODULES = 'modules';
CommonCacheService.CACHE_OPERATION_TYPES = 'payment_operation_type';
CommonCacheService.CACHE_PERMISSIONS = 'permissions';
CommonCacheService.CACHE_PLATFORM = 'platform';
CommonCacheService.CACHE_POSITIONS = 'positions';
CommonCacheService.CACHE_REASONS_NOT_SELECTED = 'reasonsNotSelected';
CommonCacheService.CACHE_RESOURCE = 'resource';
CommonCacheService.CACHE_SCOUTING_RATINGS = 'scoutingratings';
CommonCacheService.CACHE_SEASONS = 'seasons';
CommonCacheService.CACHE_SECURETABS = 'securetabs';
CommonCacheService.CACHE_SHAREPERMISSIONS = 'sharePermissions';
CommonCacheService.CACHE_SURFACES = 'surfaces';
CommonCacheService.CACHE_TEAMS = 'teams';
CommonCacheService.CACHE_TERRAIN = 'terrains';
CommonCacheService.CACHE_TRAININGSUBTYPES = 'trainingSubTypes';
CommonCacheService.CACHE_TRANSLATIONS = 'translations';
CommonCacheService.CACHE_USERS = 'users';
class Cache {
    constructor(cacheName, timeToIdleSeconds, timeToLiveSeconds, localStorage = false, objectType) {
        this.items = {};
        this.cacheName = cacheName;
        this.timeToIdleSeconds = timeToIdleSeconds;
        this.timeToLiveSeconds = timeToLiveSeconds;
        this.localStorage = localStorage;
        this.objectType = objectType;
    }
    getCacheItem(id) {
        let cacheItem = null;
        if (this.localStorage && localStorage.getItem('environment') != 'DEV') {
            // we get it from the persistent cache of the browser
            if (localStorage.getItem(this.getLocalStorageItemId(id)) != null) {
                let storageItem = JSON.parse(localStorage.getItem(this.getLocalStorageItemId(id)));
                cacheItem = new CacheItem(storageItem.value);
                cacheItem.array = storageItem.array;
                cacheItem.lastAccessDate = storageItem.lastAccessDate;
                cacheItem.creationDate = storageItem.creationDate;
            }
        }
        else {
            // we get it from the session cache
            if (this.items[id]) {
                cacheItem = this.items[id];
            }
        }
        return cacheItem;
    }
    getLocalStorageItemId(id) {
        return localStorage.getItem('apiBaseURL') + '||' + this.cacheName + '||' + id;
    }
    putCacheItem(id, value) {
        let cacheItem = new CacheItem(value);
        if (value instanceof Array) {
            cacheItem.array = true;
        }
        if (this.localStorage && localStorage.getItem('environment') != 'DEV') {
            // we store in the persistent cache of the browser
            localStorage.setItem(this.getLocalStorageItemId(id), JSON.stringify(cacheItem));
        }
        else {
            // we store it in the session cache
            this.items[id] = cacheItem;
        }
    }
    removeFromCache(id) {
        if (this.localStorage && localStorage.getItem('environment') != 'DEV') {
            // we delete it from the persistent cache of the browser
            localStorage.removeItem(this.getLocalStorageItemId(id));
        }
        else {
            // we delete it from the session
            delete this.items[id];
        }
    }
}
class CacheItem {
    constructor(value) {
        this.array = false;
        this.value = value;
        this.creationDate = new Date().getTime();
        this.lastAccessDate = new Date().getTime();
    }
}

class PermissionService extends BaseService {
    constructor(angulartics2, authHttp, configParamsService, http, cacheService) {
        super();
        this.angulartics2 = angulartics2;
        this.authHttp = authHttp;
        this.configParamsService = configParamsService;
        this.http = http;
        this.cacheService = cacheService;
        this.cachedPermissions = {};
        this.cachedSupportedModules = {};
    }
    get loggedIn() {
        return this.configParamsService.getConfigParam('loggedIn') != 'false';
    }
    get baseDomain() {
        return this.configParamsService.getConfigParam('baseDomain');
    }
    get chinaPlatform() {
        return this.configParamsService.getConfigParam('china') == '1';
    }
    get currentMember() {
        if (this._currentMember == null && this.currentUser != null) {
            this._currentMember = this.currentUser.member;
        }
        return this._currentMember;
    }
    get currentMemberSessionId() {
        return this.configParamsService.getConfigParam('sessionId');
    }
    get currentMemberGlobalAdmin() {
        return parseInt(this.configParamsService.getConfigParam('globalAdmin')) == 1;
    }
    get currentMemberConfigUser() {
        return parseInt(this.configParamsService.getConfigParam('configUser')) == 1;
    }
    get currentMemberClubId() {
        return parseInt(this.configParamsService.getConfigParam('memberClubId'));
    }
    get currentMemberCognito() {
        if (this._currentCognito == null && this.configParamsService.getConfigParam('cognito') != null) {
            this._currentCognito = new Cognito().deserialize(JSON.parse(this.configParamsService.getConfigParam('cognito')));
        }
        return this._currentCognito;
    }
    set currentMemberCognito(cognito) {
        this._currentCognito = null;
        this.configParamsService.setConfigParam('cognito', JSON.stringify(cognito));
    }
    get currentMemberId() {
        return parseInt(this.configParamsService.getConfigParam('memberId'));
    }
    get currentMemberIsPlayer() {
        return this.configParamsService.getConfigParam('userPlayer') == 'true';
    }
    get currentMemberIsStaff() {
        return this.configParamsService.getConfigParam('userStaff') == 'true';
    }
    get currentMemberLanguage() {
        return this.configParamsService.getConfigParam('userLanguage');
    }
    get currentVersion() {
        return localStorage.getItem('currentVersion');
    }
    get currentPlatform() {
        if (this._currentPlatform == null && this.configParamsService.getConfigParam('platform') != null) {
            this._currentPlatform = new Platform().deserialize(JSON.parse(this.configParamsService.getConfigParam('platform')));
        }
        return this._currentPlatform;
    }
    get currentUser() {
        if (this._currentUser == null && this.configParamsService.getConfigParam('currentUser') != null) {
            this._currentUser = new User().deserialize(JSON.parse(this.configParamsService.getConfigParam('currentUser')));
            localStorage.setItem('currentUser', JSON.stringify(this._currentUser));
        }
        return this._currentUser;
    }
    get currentUserIsSpoc() {
        if (this.configParamsService.getConfigParam('currentUser') != null) {
            this._currentUser = new User().deserialize(JSON.parse(this.configParamsService.getConfigParam('currentUser')));
            return this._currentUser.spoc;
        }
        return false;
    }
    get environmentType() {
        return this.configParamsService.getConfigParam('environment');
    }
    get footbelAPIEnabled() {
        return !this.currentPlatform.international && this.currentPlatform.club.footbelId != null;
    }
    get internationalPlatform() {
        return this.currentPlatform.international;
    }
    get soccerPlatform() {
        if (this.currentPlatform != null) {
            return this.currentPlatform.type == 'soccer' || this.currentPlatform.type == 'volley' || this.currentPlatform.type == 'hockey' || this.currentPlatform.type == 'futsal';
        }
        else {
            return false;
        }
    }
    get hockeyPlatform() {
        if (this.currentPlatform != null) {
            return this.currentPlatform.type == 'hockey';
        }
        else {
            return false;
        }
    }
    get tennisPlatform() {
        if (this.currentPlatform != null) {
            return this.currentPlatform.type == 'tennis';
        }
        else {
            return false;
        }
    }
    get volleyPlatform() {
        if (this.currentPlatform != null) {
            return this.currentPlatform.type == 'volley';
        }
        else {
            return false;
        }
    }
    get currentPlatformTypeField() {
        const cloudFrontPipe = new CloudfrontPipe(this.configParamsService);
        return cloudFrontPipe.transform('/angular/assets/images/field_middel_' + this.currentPlatform.type + '.png');
    }
    getPermissions() {
        if (this._permissions == null) {
            if (this.configParamsService.getConfigParam('permissions')) {
                this._permissions = JSON.parse(this.configParamsService.getConfigParam('permissions'));
            }
        }
        return this._permissions;
    }
    hasAccessToMember(accessRight, memberId) {
        let memberIds = this.getPermissionMembers(accessRight);
        return memberIds.indexOf(memberId) >= 0;
    }
    hasPermission(accessRight, team) {
        if (team != null && Array.isArray(team)) {
            team = team.join(',');
        }
        if (team != null) {
            team = String(team);
        }
        if (team != null && accessRight + '|team|' + team in this.cachedPermissions) {
            return this.cachedPermissions[accessRight + '|team|' + team];
        }
        else if (team == null && accessRight in this.cachedPermissions) {
            return this.cachedPermissions[accessRight];
        }
        else {
            let permissions = this.getPermissions();
            let hasPermission = false;
            if (permissions != null) {
                for (let permission of permissions) {
                    if (accessRight != null && permission.accessRight != null && permission.accessRight.toUpperCase() == accessRight) {
                        if (permission.requiresTeam && team != null) {
                            for (let teamId of permission.teams) {
                                if (team != null && team.indexOf(',') >= 0) {
                                    for (let checkTeamId of team.split(',')) {
                                        if (teamId == checkTeamId) {
                                            hasPermission = true;
                                            break;
                                        }
                                    }
                                }
                                else {
                                    if (teamId == team) {
                                        hasPermission = true;
                                        break;
                                    }
                                }
                            }
                        }
                        else {
                            hasPermission = permission.permission;
                        }
                        break;
                    }
                }
                if (team != null) {
                    this.cachedPermissions[accessRight + '|team|' + team] = hasPermission;
                }
                else {
                    this.cachedPermissions[accessRight] = hasPermission;
                }
            }
            return hasPermission;
        }
    }
    hasGroupPermission(accessRight, group) {
        if (group != null && Array.isArray(group)) {
            group = group.join(',');
        }
        if (group != null) {
            group = String(group);
        }
        if (group != null && accessRight + '|group|' + group in this.cachedPermissions) {
            return this.cachedPermissions[accessRight + '|team|' + group];
        }
        else if (group == null && accessRight in this.cachedPermissions) {
            return this.cachedPermissions[accessRight];
        }
        else {
            let permissions = this.getPermissions();
            let hasPermission = false;
            if (permissions != null) {
                for (let permission of permissions) {
                    if (accessRight != null && permission.accessRight != null && permission.accessRight.toUpperCase() == accessRight) {
                        if (permission.requiresGroup && group != null) {
                            for (let groupId of permission.groups) {
                                if (group != null && group.indexOf(',') >= 0) {
                                    for (let checkGroupId of group.split(',')) {
                                        if (groupId == checkGroupId) {
                                            hasPermission = true;
                                            break;
                                        }
                                    }
                                }
                                else {
                                    if (groupId == group) {
                                        hasPermission = true;
                                        break;
                                    }
                                }
                            }
                        }
                        else {
                            hasPermission = permission.permission;
                        }
                        break;
                    }
                }
            }
            if (group != null) {
                this.cachedPermissions[accessRight + '|group|' + group] = hasPermission;
            }
            else {
                this.cachedPermissions[accessRight] = hasPermission;
            }
            return hasPermission;
        }
    }
    getPermissionMembers(accessRight) {
        let permissionMembers = new Array();
        let permissions = this.getPermissions();
        for (let permission of permissions) {
            if (accessRight != null && permission.accessRight != null && permission.accessRight.toUpperCase() == accessRight) {
                if (permission.requiresMember) {
                    for (let memberId of permission.members) {
                        permissionMembers.push(parseInt(memberId));
                    }
                }
            }
        }
        return permissionMembers;
    }
    // function user_rechten_teams
    getPermissionTeams(accessRight) {
        let permissionTeams = new Array();
        let permissions = this.getPermissions();
        for (let permission of permissions) {
            if (accessRight != null && permission.accessRight != null && permission.accessRight.toUpperCase() == accessRight) {
                if (permission.requiresTeam) {
                    for (let teamId of permission.teams) {
                        permissionTeams.push(parseInt(teamId));
                    }
                }
            }
        }
        return permissionTeams;
    }
    // function user_rechten_groups
    getPermissionGroups(accessRight) {
        let permissionGroups = new Array();
        let permissions = this.getPermissions();
        for (let permission of permissions) {
            if (accessRight != null && permission.accessRight != null && permission.accessRight.toUpperCase() == accessRight) {
                if (permission.requiresGroup) {
                    for (let groupId of permission.groups) {
                        permissionGroups.push(parseInt(groupId));
                    }
                }
            }
        }
        return permissionGroups;
    }
    initCurrentPlatform() {
        return Observable.create(observer => {
            this.http
                .get(localStorage.getItem('apiBaseURL') + '/platforms/current')
                .pipe(map(platformJson => {
                return platformJson;
            }))
                .subscribe(platformJson => {
                this._currentPlatform = null;
                this.configParamsService.setConfigParam('platform', JSON.stringify(platformJson));
                observer.next(new Platform().deserialize(platformJson));
                observer.complete();
            });
        });
    }
    initCurrentUser(clearCache = false) {
        return Observable.create(observer => {
            this.authHttp
                .get('/users/current')
                .pipe(map(userJson => {
                if (userJson != null && userJson.body != null && userJson.body != '') {
                    return userJson.body;
                }
                else {
                    return null;
                }
            }))
                .subscribe(userJson => {
                if (userJson != null) {
                    let user = new User().deserialize(userJson);
                    // set the logging user context
                    configureScope(scope => {
                        scope.setUser({
                            id: String(user.id),
                            username: user.username
                        });
                    });
                    this.configParamsService.setConfigParam('currentUser', JSON.stringify(userJson));
                    if (user.member != null && user.member.id != null) {
                        this.configParamsService.setConfigParam('memberClubId', user.member.getClub(this.currentPlatform.international).toString());
                        this.configParamsService.setConfigParam('memberId', user.member.id.toString());
                        this.configParamsService.setConfigParam('userPlayer', String(user.player));
                        this.configParamsService.setConfigParam('userStaff', String(user.staff));
                    }
                    observer.next(user);
                    observer.complete();
                }
                else {
                    observer.next(null);
                    observer.complete();
                }
            });
        });
    }
    initPermissions() {
        this.cachedPermissions = {};
        this._permissions = null;
        this.configParamsService.clearConfigParam('permissions');
        return Observable.create(observer => {
            this.authHttp
                .get('/permissions')
                .pipe(map(permissionsJson => {
                return JSON.stringify(permissionsJson.body);
            }))
                .subscribe(permissions => {
                this.configParamsService.setConfigParam('permissions', permissions);
                observer.next(permissions);
                observer.complete();
            });
        });
    }
    isSupportedModule(module, sub, page) {
        let key = module + '-' + sub + '-' + page;
        if (this.cachedSupportedModules[key] != null) {
            return this.cachedSupportedModules[key];
        }
        else {
            let isSupported = false;
            if (this._supportedModules == null) {
                this._supportedModules = JSON.parse(this.configParamsService.getConfigParam('supportedModules'));
            }
            if (page != null && page != '') {
                sub = sub + '-' + page;
            }
            if (this._supportedModules != null && this._supportedModules[module]) {
                if (this._supportedModules[module] instanceof Array) {
                    isSupported = this._supportedModules[module].indexOf(sub) >= 0;
                    if (!isSupported) {
                        isSupported = this._supportedModules[module].indexOf(page) >= 0;
                    }
                }
                else {
                    isSupported = this._supportedModules[module];
                }
            }
            return isSupported;
        }
    }
}
PermissionService.ɵfac = function PermissionService_Factory(t) { return new (t || PermissionService)(ɵɵinject(Angulartics2), ɵɵinject(HttpAuthentication), ɵɵinject(ConfigParamsService), ɵɵinject(HttpClient), ɵɵinject(CommonCacheService)); };
PermissionService.ɵprov = ɵɵdefineInjectable({ token: PermissionService, factory: PermissionService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PermissionService, [{
        type: Injectable
    }], function () { return [{ type: Angulartics2 }, { type: HttpAuthentication }, { type: ConfigParamsService }, { type: HttpClient }, { type: CommonCacheService }]; }, null); })();

class DateTimeUtil {
    static getCombinedDate(date, time) {
        let combinedDate = new Date();
        if (CommonUtil.isString(date)) {
            combinedDate = DateTimeUtil.getFromString(date);
        }
        else if (CommonUtil.isNumeric(date)) {
            combinedDate.setTime(date);
        }
        else if (CommonUtil.isDate(date)) {
            combinedDate.setTime(date.getTime());
        }
        if (CommonUtil.isString(time)) {
            combinedDate.setHours(DateTimeUtil.getTimeFromString(time).getHours());
            combinedDate.setMinutes(DateTimeUtil.getTimeFromString(time).getMinutes());
        }
        else if (CommonUtil.isNumeric(time)) {
            combinedDate.setHours(moment$1.unix(time / 1000).hours());
            combinedDate.setMinutes(moment$1.unix(time / 1000).minutes());
        }
        else {
            combinedDate.setHours(moment$1(time).hours());
            combinedDate.setMinutes(moment$1(time).minutes());
        }
        return combinedDate.getTime();
    }
    static getFromString(dateString) {
        return moment$1(dateString, 'YYYY-MM-DD HH:mm').toDate();
    }
    static getFromDateString(dateString, format) {
        let dateFormat = format ? format : 'YYYY-MM-DD';
        return moment$1(dateString, dateFormat).toDate();
    }
    static getTimeFromString(timeString) {
        return moment$1(timeString, 'HH:mm').toDate();
    }
    static getSecondsFromTimeString(timeString) {
        let secs;
        if (timeString) {
            let minutesAndSeconds = timeString.split(':');
            let minutes = Number(minutesAndSeconds[0]);
            let seconds = Number(minutesAndSeconds[1]);
            secs = minutes * 60 + seconds;
        }
        return secs;
    }
    static getDateFromString(dateString, format, applyTimeZone = true) {
        if (DateTimeUtil.TIMEZONE == null) {
            let permissionService = APP_INJECTOR.get(PermissionService);
            DateTimeUtil.TIMEZONE = permissionService.currentPlatform.timeZone;
        }
        return moment$1(dateString, format).unix() * 1000;
    }
    static getFormattedTime(time, format = 'HH:mm', defaultValue = null, applyTimeZone = true) {
        if (DateTimeUtil.TIMEZONE == null) {
            let permissionService = APP_INJECTOR.get(PermissionService);
            DateTimeUtil.TIMEZONE = permissionService.currentPlatform.timeZone;
        }
        let formattedTime;
        if (CommonUtil.isString(time)) {
            if (time.indexOf('-') > 0) {
                formattedTime = moment$1(time, 'YYYY-MM-DD HH:mm').format(format);
            }
            else {
                formattedTime = moment$1(time, 'HH:mm').format(format);
            }
        }
        else if (CommonUtil.isNumeric(time)) {
            formattedTime = moment$1.unix(time / 1000).format(format);
        }
        else if (CommonUtil.isDate(time)) {
            formattedTime = moment$1(time).format(format);
        }
        else if (defaultValue != null) {
            formattedTime = defaultValue;
        }
        else {
            formattedTime = '';
        }
        return formattedTime;
    }
    static getCurrentDate() {
        return moment$1(new Date(), 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
    }
    static getFormattedDate(date, format, defaultValue = null, applyTimeZone = true, language) {
        if (DateTimeUtil.TIMEZONE == null) {
            let permissionService = APP_INJECTOR.get(PermissionService);
            DateTimeUtil.TIMEZONE = permissionService.currentPlatform.timeZone;
        }
        let formattedDate;
        if (language == null) {
            moment$1.locale(UserUtil.getUserLanguage() === 'zh' ? 'zh-CN' : UserUtil.getUserLanguage());
        }
        else {
            moment$1.locale(language);
        }
        if (CommonUtil.isString(date)) {
            formattedDate = moment$1(date, 'YYYY-MM-DD HH:mm', language).format(format);
        }
        else if (CommonUtil.isNumeric(date)) {
            formattedDate = moment$1.unix(date / 1000).format(format);
        }
        else if (CommonUtil.isDate(date)) {
            formattedDate = moment$1(date).format(format);
        }
        else if (defaultValue != null) {
            formattedDate = defaultValue;
        }
        else {
            formattedDate = '';
        }
        return formattedDate;
    }
    static getMinutesFromTime(time) {
        return Math.round(time / 1000 / 60);
    }
    static getTimeFromMins(mins) {
        // do not include the first validation check if you want, for example,
        // getTimeFromMins(1530) to equal getTimeFromMins(90) (i.e. mins rollover)
        if (mins > 24 * 60) {
            mins = 24 * 60;
        }
        else if (mins < 0) {
            mins = 0;
        }
        let h = (mins / 60) | 0, m = mins % 60 | 0;
        return moment$1
            .utc()
            .hours(h)
            .minutes(m)
            .format('HH:mm');
    }
    static getWeekNumber(d) {
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
        let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        let weekNo = Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
        return weekNo;
    }
    static getWeekYear(d) {
        return Number(moment$1(d).format('gggg'));
    }
    static getHoursFromMinutes(mins) {
        return Math.floor(mins / 60) + ':' + (mins % 60);
    }
    static isBefore(date, date2) {
        if (date2) {
            return moment$1(date).isBefore(date2);
        }
        else {
            // is before today
            return moment$1(date).isBefore();
        }
    }
    static isAfter(date, date2) {
        if (date2) {
            return moment$1(date).isAfter(date2);
        }
        else {
            // is before today
            return moment$1(date).isAfter();
        }
    }
}
DateTimeUtil.TIMEZONE = null;

class ApiUtil {
    static processApiUrl(apiUrl, paramObject) {
        let processedApiUrl = apiUrl;
        if (paramObject != null) {
            for (let prop in paramObject) {
                if (paramObject.hasOwnProperty(prop)) {
                    processedApiUrl = processedApiUrl.replace('{' + prop + '}', encodeURIComponent(paramObject[prop]));
                }
            }
        }
        return processedApiUrl;
    }
}

class AuthenticationService extends BaseService {
    constructor(authHttp, httpClient, cookieService) {
        super();
        this.authHttp = authHttp;
        this.httpClient = httpClient;
        this.cookieService = cookieService;
        this.USERS_IMPERSONATE = '/users/impersonate'; // todo: do we still need this one?
        this.LOGIN = '/login/oauth/token?platform={platform}';
        this.USERS_POSSIBLE_USERS = '/central-users/current/possible-users?platform={platform}';
        this.USERS_SELECT = '/central-users/select';
        this.USERS_RESEND_ACTIVATION = '/central-users/resend-user-verification?email={email}';
        this.FORGOT_PASSWORD = '/central-users/forgot-password?platformId={platformId}'; // trigger forgot password => mail will be send
        this.CHANGE_PASSWORD = '/central-users/change-password'; // used when saving password on the account settings page
        this.RESET_PASSWORD = '/central-users/reset-password?platformId={platformId}'; // call reset password when saving password on forgot password page
        this.SET_PASSWORD = '/central-users/set-password?platformId={platformId}&email={email}'; // call set password when saving password to activate account
        this.CREATE_USER = '/central-users/create'; // POST => create new central user (= create account / user) and on trial first step + GET with req param activation token => activation of a user when created on control panel
        this.EMAIL_CHECK = '/login/email-check?email={email}&platform={platform}';
        this.ADMIN_LOGIN = '/login/admin-login-platform?platform={platform}';
        this.GLOBAL_LOGOUT = '/login/logout';
    }
    isLoggedIn(prod) {
        let accessTokenCookie = this.cookieService.getCentralCookie('central_access_token', prod);
        let refreshTokenCookie = this.cookieService.getCentralCookie('central_refresh_token', prod);
        let userEmail = localStorage.getItem('userEmail');
        if (accessTokenCookie == '' && refreshTokenCookie != '') {
            return this.refreshCentralAccessToken(userEmail, refreshTokenCookie, null).pipe(map(_result => {
                CookieUtil.setCentralCookies(_result.access_token, _result.refresh_token, prod, _result.expires_in);
                return true;
            }), catchError(err => {
                this.cookieService.deleteCentralCookie('central_access_token', prod);
                this.cookieService.deleteCentralCookie('central_refresh_token', prod);
                return of(false);
            }));
        }
        else if (accessTokenCookie != '' && refreshTokenCookie != '') {
            return Observable.create(observer => {
                observer.next(true);
                observer.complete();
            });
        }
        else {
            return Observable.create(observer => {
                this.cookieService.deleteCentralCookie('central_access_token', prod);
                this.cookieService.deleteCentralCookie('central_refresh_token', prod);
                observer.next(false);
                observer.complete();
            });
        }
    }
    /**
     * Login to the (central) app /
     * @param type
     * @param userName
     * @param password
     * @param platform
     * @param mfaClientData
     * @param mfaIp
     * @param mfaOrigin
     * @param mfaCode
     * @param mfaChallenge
     * @param mfaSessionId
     */
    login(type = 'login', userName, password, platform, mfaClientData, mfaIp, mfaOrigin, mfaCode, mfaChallenge, mfaSessionId) {
        let authenticationObject = {
            login: userName,
            password: password,
            type: type,
            grant_type: 'password',
            mfa_clientdata: mfaClientData != null ? mfaClientData : '',
            mfa_ip: mfaIp != null ? mfaIp : '',
            mfa_origin: mfaOrigin != null ? mfaOrigin : '',
            mfa_code: mfaCode != null ? mfaCode : '',
            mfa_challenge: mfaChallenge != null ? mfaChallenge : '',
            mfa_sessionid: mfaSessionId != null ? mfaSessionId : ''
        };
        let jsonParamObject = {
            platform: platform != null ? platform : ''
        };
        return this.authHttp.post(ApiUtil.processApiUrl(this.LOGIN, jsonParamObject), JSON.stringify(authenticationObject), null, false, null, null).pipe(map(result => {
            return result.body;
        }, error => {
            return error.body;
        }));
    }
    /**
     * Refresh access token for the central app
     * @param userName
     * @param refreshToken
     * @param platform
     */
    refreshCentralAccessToken(userName, refreshToken, platform) {
        let jsonParamObject = {
            platform: platform != null ? platform : ''
        };
        return this.authHttp
            .post(ApiUtil.processApiUrl(this.LOGIN, jsonParamObject), JSON.stringify({ login: userName, type: 'login', refresh_token: refreshToken, grant_type: 'refresh_token' }), null, false, null, null)
            .pipe(map(result => {
            return result.body;
        }, error => {
            return error.body;
        }));
    }
    /**
     * Generate OAuth2 access token for impersonated user
     * @param selectUserDTO
     * @param centralAccessToken
     * @param baseUrl selectUser call needs to be executed on the specific platform API URL
     */
    selectUser(selectUserDTO, centralAccessToken, baseUrl) {
        if (centralAccessToken) {
            return this.authHttp.post(this.USERS_SELECT, JSON.stringify(selectUserDTO), null, null, null, centralAccessToken, baseUrl).pipe(map(result => {
                return result.body;
            }));
        }
    }
    /**
     * impersonate user
     * returns OAuth access token
     * // todo: do we still need this call?
     */
    impersonate(impersonateUser) {
        return this.authHttp.post(this.USERS_IMPERSONATE, JSON.stringify(impersonateUser)).pipe(map(result => {
            return result.body;
        }));
    }
    /**
     * Get all available users for central user
     * @param centralAccessToken
     * @param platformId
     */
    loadCurrentPossibleUsers(centralAccessToken, platform) {
        let jsonParamObject = { platform: platform != null ? platform : '' };
        if (centralAccessToken) {
            return this.authHttp.get(ApiUtil.processApiUrl(this.USERS_POSSIBLE_USERS, jsonParamObject), null, null, null, centralAccessToken).pipe(map(result => {
                return deserializeList(result.body, function (item) {
                    return new PlatformUserDto().deserialize(item);
                });
            }));
        }
    }
    /**
     * logout from the (central) app
     */
    logout(environment, centralAccessToken) {
        return new Observable(observer => {
            let domain = document.domain.split('.').reverse().splice(0, 2).reverse().join('.');
            localStorage.removeItem('userEmail');
            localStorage.removeItem('userFirstName');
            this.cookieService.deleteCentralCookie('central_access_token', environment.production, '/', domain);
            this.cookieService.deleteCentralCookie('central_refresh_token', environment.production, '/', domain);
            this.cookieService.delete('platform_refresh_token', '/', window.location.hostname);
            this.cookieService.delete('platform_access_token', '/', window.location.hostname);
            if (centralAccessToken) {
                this.globalLogout(centralAccessToken).subscribe(() => {
                    observer.next();
                    observer.complete();
                });
            }
            else {
                observer.next();
                observer.complete();
            }
        });
    }
    /**
     * Global logout FN
     * @returns {Observable<any>}
     */
    globalLogout(centralAccessToken) {
        return this.authHttp.delete(this.GLOBAL_LOGOUT, null, centralAccessToken);
    }
    /**
     * Initiate resetting a password
     * @param email
     * @param platformId
     */
    forgotPassword(email, platformId) {
        let jsonParams = {
            platformId: platformId != null ? platformId : ''
        };
        return this.authHttp.post(ApiUtil.processApiUrl(this.FORGOT_PASSWORD, jsonParams), JSON.stringify({ username: email }));
    }
    /**
     * Change password - used when updating password on the account settings page (central login)
     * @param centralAccessToken
     * @param changePasswordDTO
     */
    changePassword(centralAccessToken, changePasswordDTO) {
        return this.authHttp.put(this.CHANGE_PASSWORD, JSON.stringify(changePasswordDTO), null, centralAccessToken);
    }
    /**
     * Reset password - used when setting a new password through the 'forgot password' option
     * @param resetPasswordDTO
     * @param platformId
     */
    resetPassword(resetPasswordDTO, platformId) {
        let jsonParam = {
            platformId: platformId != null ? platformId : ''
        };
        return this.authHttp.put(ApiUtil.processApiUrl(this.RESET_PASSWORD, jsonParam), JSON.stringify(resetPasswordDTO));
    }
    /**
     * Set password - used when setting a new password to activate an account
     * @param resetPasswordDTO
     * @param platformId
     * @param email
     */
    setPassword(resetPasswordDTO, platformId, email) {
        let jsonParam = {
            platformId: platformId != null ? platformId : '',
            email: email
        };
        return this.authHttp.put(ApiUtil.processApiUrl(this.SET_PASSWORD, jsonParam), JSON.stringify(resetPasswordDTO));
    }
    /**
     * Create a new central user
     */
    createCentralUser(createCentralUserDTO, trialCreation = false, joinToken, platform) {
        let apiURL = this.CREATE_USER;
        apiURL += '?trialCreation=' + (trialCreation == true ? 'true' : 'false');
        if (joinToken) {
            apiURL += '&joinToken=' + joinToken;
        }
        if (platform) {
            apiURL += '&platform=' + platform;
        }
        return this.authHttp.post(apiURL, JSON.stringify(createCentralUserDTO)).pipe(map(result => {
            return result.body;
        }));
    }
    /**
     * Check the email you want to login with
     */
    checkEmail(email, platformPrefix) {
        let jsonParamObject = {
            email: email,
            platform: platformPrefix != null ? platformPrefix : ''
        };
        return this.authHttp.get(ApiUtil.processApiUrl(this.EMAIL_CHECK, jsonParamObject)).pipe(map(result => {
            return new CentralUserEmailStatusDTO().deserialize(result.body);
        }));
    }
    /**
     * Log in to a platform as admin user
     */
    adminPlatformLogIn(platform, centralAccessToken, refreshToken, expiresIn, baseUrl) {
        let jsonParamObject = {
            platform: platform
        };
        let oAuthToken = {
            access_token: centralAccessToken,
            refresh_token: refreshToken,
            expires_in: expiresIn
        };
        return this.authHttp.post(ApiUtil.processApiUrl(this.ADMIN_LOGIN, jsonParamObject), oAuthToken, null, null, null, null, baseUrl).pipe(map(result => {
            return result.body;
        }));
    }
    /**
     * Resend (central) user activation mail
     */
    resendActivation(email, platform, isTrialCreation = false) {
        let jsonParamObject = {
            email: email
        };
        let url = ApiUtil.processApiUrl(this.USERS_RESEND_ACTIVATION, jsonParamObject);
        if (isTrialCreation) {
            url += '&trialCreation=true';
        }
        if (platform) {
            url += '&platform=' + platform;
        }
        return this.authHttp.post(url, '').pipe(map(result => {
            return result.body;
        }));
    }
}
AuthenticationService.ɵfac = function AuthenticationService_Factory(t) { return new (t || AuthenticationService)(ɵɵinject(HttpAuthentication), ɵɵinject(HttpClient), ɵɵinject(CookieService)); };
AuthenticationService.ɵprov = ɵɵdefineInjectable({ token: AuthenticationService, factory: AuthenticationService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthenticationService, [{
        type: Injectable
    }], function () { return [{ type: HttpAuthentication }, { type: HttpClient }, { type: CookieService }]; }, null); })();

class BillingService extends BaseService {
    constructor(authHttp) {
        super();
        this.authHttp = authHttp;
        this.ADYEN_PAYMENT_SESSION = '/adyen/session/{paymentId}?paymentAccessKey={paymentAccessKey}&language={language}&email={email}&platform={platform}&flow={flow}';
    }
    getPaymentSession(paymentSessionCreate) {
        return this.authHttp.get(ApiUtil.processApiUrl(this.ADYEN_PAYMENT_SESSION, paymentSessionCreate)).pipe(map(result => {
            return result.body;
        }));
    }
}
BillingService.ɵfac = function BillingService_Factory(t) { return new (t || BillingService)(ɵɵinject(HttpAuthentication)); };
BillingService.ɵprov = ɵɵdefineInjectable({ token: BillingService, factory: BillingService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BillingService, [{
        type: Injectable
    }], function () { return [{ type: HttpAuthentication }]; }, null); })();

class ClubService extends BaseService {
    constructor(authHttp) {
        super();
        this.authHttp = authHttp;
        this.ADD_CLUB = '/clubs';
        this.CLUBS = '/clubs?q={q}&size={size}&sort=name,asc&onlyClubPlatforms={onlyClubPlatforms}&includePlatformType={includePlatformType}&sport={sport}';
        this.CLUB_SEARCH = '/clubs/search?q={q}&size={size}';
    }
    getClub(id) {
        return this.authHttp.get('/clubs/' + id).pipe(map(result => {
            return new Club().deserialize(result.body);
        }));
    }
    searchClubs(query, numberResults, onlyClubPlatforms, includePlatformType, sport) {
        if (numberResults == null) {
            numberResults = 20;
        }
        let jsonParamObject = {
            'q': query != null ? query : '',
            'size': numberResults,
            'onlyClubPlatforms': onlyClubPlatforms != null ? onlyClubPlatforms : '',
            'includePlatformType': includePlatformType != null ? includePlatformType : true,
            'sport': sport != null ? sport : ''
        };
        return this.authHttp.get(ApiUtil.processApiUrl(this.CLUBS, jsonParamObject)).pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new Club().deserialize(item);
            });
        }));
    }
    /**
     * Search clubs and club groups
     * @param query
     * @param numberResults
     */
    searchClubsAndClubGroups(query, numberResults) {
        if (numberResults == null) {
            numberResults = 20;
        }
        let jsonParamObject = {
            'q': query != null ? query : '',
            'size': numberResults
        };
        return this.authHttp.get(ApiUtil.processApiUrl(this.CLUB_SEARCH, jsonParamObject)).pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new ClubSearchDTO().deserialize(item);
            });
        }));
    }
    addClub(club) {
        return this.authHttp.post(this.ADD_CLUB, JSON.stringify(club)).pipe(map(result => {
            return new Club().deserialize(result.body);
        }));
    }
}
ClubService.ɵfac = function ClubService_Factory(t) { return new (t || ClubService)(ɵɵinject(HttpAuthentication)); };
ClubService.ɵprov = ɵɵdefineInjectable({ token: ClubService, factory: ClubService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ClubService, [{
        type: Injectable
    }], function () { return [{ type: HttpAuthentication }]; }, null); })();

class ClubApiKey {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.user != null) {
            this.user = new User().deserialize(json.user);
        }
        return this;
    }
}

class PlatformSetting {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json != null) {
            if (json.playerAbleToChangePersonalInfo != null) {
                this.playerAbleToChangePersonalInfo = json.playerAbleToChangePersonalInfo;
            }
            if (json.playerAbleToChangeProfilePicture != null) {
                this.playerAbleToChangeProfilePicture = json.playerAbleToChangeProfilePicture;
            }
            if (json.playerAbleToIndicatePresenceTraining != null) {
                this.playerAbleToIndicatePresenceTraining = json.playerAbleToIndicatePresenceTraining;
            }
            if (json.primaryClubColor != null) {
                this.primaryClubColor = json.primaryClubColor;
            }
            if (json.secondaryClubColor != null) {
                this.secondaryClubColor = json.secondaryClubColor;
            }
        }
        return this;
    }
}

class CommonPlatformService extends BaseService {
    constructor(authHttp) {
        super();
        this.authHttp = authHttp;
        this.PLATFORMSETTINGS = '/platformsettings';
        this.PLATFORMTHEME = '/platforms/theme';
        this.PLATFORM_CURRENT = '/platforms/prefix/{prefix}';
        this.TRIAL_PLATFORM = '/platforms/trial';
        this.PLATFORM_PREFIX_AVAILABLE = '/platforms/{prefix}/available';
        this.PLATFORM_STATUS = '/platforms/{prefix}/status';
        this.PLATFORM_BACKGROUNDS = '/platforms/backgrounds';
        this.CONTACT_PLATFORM_ADMIN = '/platforms/contact/admin';
        this.PLATFORMURL = '/platforms/{prefix}/platform-url';
        this.PLATFORMS_BY_CLUB = '/platforms?clubId={clubId}';
        //central platform controllers
        this.PLATFORM_VALIDITY = '/central-platforms/{platformId}/check?regionId={regionId}';
    }
    getAvailableDomainExtensions() {
        return this.authHttp.get('/platforms/domainextensions').pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return item;
            });
        }));
    }
    getAPIKey() {
        return this.authHttp.get('/platforms/apikey').pipe(map(result => {
            return new ClubApiKey().deserialize(result.body);
        }));
    }
    enableAPIKey() {
        return this.authHttp.post('/platforms/apikey', null, null, true).pipe(map(result => {
            return new ClubApiKey().deserialize(result.body);
        }));
    }
    updateApiKeyUser(clubApiKey, member) {
        return this.authHttp.post('/platforms/apikey/' + clubApiKey.key, String(member.id)).pipe(map(result => {
            return new ClubApiKey().deserialize(result.body);
        }));
    }
    savePlatformSettings(platformSetting) {
        return this.authHttp.put('/platformsettings', JSON.stringify(platformSetting)).pipe(map(result => {
            return new PlatformSetting().deserialize(result.body);
        }));
    }
    getPlatformSettings() {
        return this.authHttp.get(ApiUtil.processApiUrl(this.PLATFORMSETTINGS)).pipe(map(result => {
            return new PlatformSetting().deserialize(result.body);
        }));
    }
    getPlatformsByClub(club) {
        return this.authHttp.get(ApiUtil.processApiUrl(this.PLATFORMS_BY_CLUB, { 'clubId': club.id })).pipe(map(result => {
            var _a;
            if (((_a = result === null || result === void 0 ? void 0 : result.body) === null || _a === void 0 ? void 0 : _a.content) && result.body.content.length > 0) {
                return result.body.content;
            }
            return [];
        }));
    }
    /**
     * Save a theme (color) for the given platform
     * @param theme
     */
    saveTheme(theme) {
        return this.authHttp.put(ApiUtil.processApiUrl(this.PLATFORMTHEME), JSON.stringify(theme)).pipe(map(result => {
            return new Platform().deserialize(result.body);
        }));
    }
    /**
     * Get platform detail info from an external platform (for example called from the PSD public app)
     * @param prefix
     */
    getExternalPlatformDetails(prefix) {
        let jsonParam = {
            'prefix': prefix
        };
        return this.authHttp.get(ApiUtil.processApiUrl(this.PLATFORM_CURRENT, jsonParam)).pipe(map(result => {
            return new Platform().deserialize(result.body);
        }));
    }
    /**
     * Create a trial platform
     * @param trialPlatformDTO
     */
    createTrialPlatform(trialPlatformDTO, centralAccessToken) {
        return this.authHttp.put(this.TRIAL_PLATFORM, JSON.stringify(trialPlatformDTO), true, centralAccessToken).pipe(map(result => {
            return new Platform().deserialize(result.body);
        }));
    }
    /**
     *  Check if a prefix is still available to create a new platform
     */
    checkPrefixAvailability(prefix) {
        let jsonParam = {
            'prefix': prefix
        };
        return this.authHttp.get(ApiUtil.processApiUrl(this.PLATFORM_PREFIX_AVAILABLE, jsonParam)).pipe(map(result => {
            return result.body;
        }));
    }
    /**
     * Check the progress of the platform creation
     * @param platformPrefix
     */
    checkPlatformCreationProgress(platformPrefix) {
        let jsonParam = {
            'prefix': platformPrefix
        };
        return this.authHttp.get(ApiUtil.processApiUrl(this.PLATFORM_STATUS, jsonParam)).pipe(map(result => {
            return result.body;
        }));
    }
    /**
     * Check the progress of the platform creation
     * @param baseURL
     */
    getPlatformLoginBackgrounds(baseURL) {
        return this.authHttp.get(ApiUtil.processApiUrl(this.PLATFORM_BACKGROUNDS), null, null, null, null, baseURL).pipe(map(result => {
            return result.body;
        }));
    }
    /**
     * Send an e-mail to the platform SPOC
     */
    contactPlatformAdmin(firstName, lastName, email, message, skipCaptcha = false, googleRecaptchaServerKey, googleRecaptchaToken, baseUrl) {
        let json = {
            'firstName': firstName,
            'lastName': lastName,
            'email': email,
            'message': message,
            'recaptchaServerKey': googleRecaptchaServerKey,
            'recaptchaToken': googleRecaptchaToken,
            'skipCaptcha': skipCaptcha
        };
        return this.authHttp.post(this.CONTACT_PLATFORM_ADMIN, JSON.stringify(json), null, null, null, null, baseUrl).pipe(map(result => {
            return result.body;
        }));
    }
    getPlatformURL(prefix) {
        let paramObj = { 'prefix': prefix };
        return this.authHttp.get(ApiUtil.processApiUrl(this.PLATFORMURL, paramObj), null, 'text').pipe(map(result => {
            return result.body;
        }));
    }
    executeGetPlatformValidity(jsonObject) {
        return this.authHttp.get(ApiUtil.processApiUrl(this.PLATFORM_VALIDITY, jsonObject)).pipe(map(result => {
            return result.body;
        }));
    }
}
CommonPlatformService.ɵfac = function CommonPlatformService_Factory(t) { return new (t || CommonPlatformService)(ɵɵinject(HttpAuthentication)); };
CommonPlatformService.ɵprov = ɵɵdefineInjectable({ token: CommonPlatformService, factory: CommonPlatformService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CommonPlatformService, [{
        type: Injectable
    }], function () { return [{ type: HttpAuthentication }]; }, null); })();

class Page {
    constructor(contentType) {
        this.contentType = contentType;
    }
    deserialize(json) {
        deserializeProperties(json, this);
        if (json) {
            if (json.content != null) {
                this.content = new Array();
                for (let contentElement of json.content) {
                    this.content.push(new this.contentType().deserialize(contentElement));
                }
            }
            if (json.order != null) {
                this.sort = [{
                        property: json.order.property,
                        direction: json.order.direction,
                        ignoreCase: json.order.ignoreCase,
                        ascending: json.order.ascending,
                        nullHandling: json.order.nullHandling,
                    }];
            }
        }
        return this;
    }
    deserializeAny(json) {
        deserializeProperties(json, this);
        if (json.content != null) {
            this.content = json.content;
        }
        return this;
    }
}

class ConfigPlatform {
    constructor() {
        this.intercom = true;
        this.international = false;
        this.professional = false;
        this.trainerPlatform = false;
        this.timeZone = 'Europe/Amsterdam';
        this.type = 'soccer';
        this.currency = {
            id: 1,
            name: 'Euro'
        };
        this.language = {
            code: 'nl',
            name: 'Nederlands'
        };
    }
    deserialize(json) {
        deserializeProperties(json, this);
        if (json.club != null) {
            this.club = new Club().deserialize(json.club);
        }
        if (json.language != null) {
            this.language = new Language().deserialize(json.language);
        }
        if (json.currency != null) {
            this.currency = new Currency().deserialize(json.currency);
        }
        return this;
    }
}

class ConfigSpoc {
    constructor() { }
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
    get name() {
        return this.fullName + (this.admin ? ' (admin)' : '');
    }
}

class VideoProfile {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class VideoPlanPrice {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class VideoPlan {
    deserialize(json) {
        deserializeProperties(json, this);
        if (json) {
            if (json.videoProfile != null) {
                this.videoProfile = new VideoProfile().deserialize(json.videoProfile);
            }
            if (json.price != null) {
                this.price = new VideoPlanPrice().deserialize(json.price);
            }
        }
        return this;
    }
}

class ConfigPlatformDetails extends ConfigPlatform {
    constructor() {
        super();
        this.activatedModules = [];
        this.spoc = [];
    }
    deserialize(json) {
        super.deserialize(json);
        if (json.activatedModules != null) {
            this.activatedModules = deserializeList(json.activatedModules, function (item) {
                return String(item);
            });
        }
        if (json.spoc != null) {
            this.spoc = deserializeList(json.spoc, function (item) {
                return new ConfigSpoc().deserialize(item);
            });
        }
        if (json.partnerClub != null) {
            this.partnerClub = new Club().deserialize(json.partnerClub);
        }
        if (json.videoPlan != null) {
            this.videoPlan = new VideoPlan().deserialize(json.videoPlan);
        }
        return this;
    }
    get fullDomainExtension() {
        return 'prosoccerdata' + this.domainExtension;
    }
}

class TermsOfUse {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class ConfigService extends BaseService {
    constructor(authHttp) {
        super();
        this.authHttp = authHttp;
        this.CONFIG_PLATFORMS_SAVE = '/config/platforms';
        this.CONFIG_PLATFORMS_FIND = '/config/platforms?q={q}';
        this.CONFIG_PROCESSING_PLATFORMS = '/config/platforms/processing';
        this.CONFIG_PLATFORM_DETAILS = '/config/platforms/{id}';
        this.CONFIG_PLATFORM_SPOC = '/config/platforms/{id}/spoc?q={q}';
        this.CONFIG_PLATFORM_MODULES = '/config/modules';
        this.CONFIG_PLATFORM_TYPES = '/config/platforms/types';
        this.CONFIG_PLATFORM_TIMEZONES = '/config/platforms/timezones';
        this.CONFIG_ALL_TERMS_OF_USES = '/config/termsofuses/';
    }
    findSpoc(platformId, q) {
        let jsonParamObject = {
            id: platformId,
            q: q ? q : ''
        };
        return this.authHttp.get(ApiUtil.processApiUrl(this.CONFIG_PLATFORM_SPOC, jsonParamObject)).pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new ConfigSpoc().deserialize(item);
            });
        }));
    }
    getConfigPlatforms(q, pageRequest) {
        let jsonParamObject = { q: q ? q : '' };
        return this.authHttp.get(ApiUtil.processApiUrl(this.CONFIG_PLATFORMS_FIND, jsonParamObject), pageRequest).pipe(map(result => {
            return new Page(ConfigPlatform).deserialize(result.body);
        }));
    }
    getProcessingConfigPlatforms(pageRequest) {
        return this.authHttp.get(this.CONFIG_PROCESSING_PLATFORMS, pageRequest).pipe(map(result => {
            return new Page(ConfigPlatform).deserialize(result.body);
        }));
    }
    getConfigPlatformDetails(id) {
        return this.authHttp
            .get(ApiUtil.processApiUrl(this.CONFIG_PLATFORM_DETAILS, {
            id: id
        }))
            .pipe(map(result => {
            return new ConfigPlatformDetails().deserialize(result.body);
        }));
    }
    getConfigModules() {
        return this.authHttp.get(this.CONFIG_PLATFORM_MODULES).pipe(map(result => {
            return result.body;
        }));
    }
    getConfigPlatformTypes() {
        return this.authHttp.get(this.CONFIG_PLATFORM_TYPES).pipe(map(result => {
            return result.body;
        }));
    }
    getSupportedTimezones() {
        return this.authHttp.get(this.CONFIG_PLATFORM_TIMEZONES).pipe(map(result => {
            return result.body;
        }));
    }
    save(configPlatformDetails) {
        if (configPlatformDetails.id == null) {
            return this.authHttp.post(this.CONFIG_PLATFORMS_SAVE, JSON.stringify(configPlatformDetails)).pipe(map(result => {
                return new ConfigPlatformDetails().deserialize(result.body);
            }));
        }
        else {
            return this.authHttp.put(this.CONFIG_PLATFORMS_SAVE, JSON.stringify(configPlatformDetails)).pipe(map(result => {
                return new ConfigPlatformDetails().deserialize(result.body);
            }));
        }
    }
    /**
     * Get all terms of use
     * @returns {Observable<Array<TermsOfUse>>}
     */
    getAllTermsOfUses() {
        return this.authHttp.get(this.CONFIG_ALL_TERMS_OF_USES, null).pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new TermsOfUse().deserialize(item);
            });
        }));
    }
    /**
     * Save Term of use
     * @returns {Observable<<TermsOfUse>}
     */
    saveTermsOfUse(termOfUse) {
        return this.authHttp.post(this.CONFIG_ALL_TERMS_OF_USES, JSON.stringify(termOfUse)).pipe(map(result => {
            return new TermsOfUse().deserialize(result.body);
        }));
    }
}
ConfigService.ɵfac = function ConfigService_Factory(t) { return new (t || ConfigService)(ɵɵinject(HttpAuthentication)); };
ConfigService.ɵprov = ɵɵdefineInjectable({ token: ConfigService, factory: ConfigService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ConfigService, [{
        type: Injectable
    }], function () { return [{ type: HttpAuthentication }]; }, null); })();

class CustomPreloadingStrategyService {
    preload(route, load) {
        const loadRoute = delay => (delay ? timer(150).pipe(flatMap(_ => load())) : load());
        return route.data && route.data.preload ? loadRoute(route.data.delay) : of(null);
    }
}
CustomPreloadingStrategyService.ɵfac = function CustomPreloadingStrategyService_Factory(t) { return new (t || CustomPreloadingStrategyService)(); };
CustomPreloadingStrategyService.ɵprov = ɵɵdefineInjectable({ token: CustomPreloadingStrategyService, factory: CustomPreloadingStrategyService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CustomPreloadingStrategyService, [{
        type: Injectable
    }], null, null); })();

class CommonUserService extends BaseService {
    constructor(authHttp, cacheService, http, cookieService, authenticationService) {
        super();
        this.authHttp = authHttp;
        this.cacheService = cacheService;
        this.http = http;
        this.cookieService = cookieService;
        this.authenticationService = authenticationService;
        this.CHANGE_PASSWORD = '/users/changepassword';
        this.CURRENT_USER = '/users/current';
        this.JOIN_PLATFORM = '/users/join-platform?joinToken={joinToken}&email={email}&centralUserId={centralUserId}&activationToken={activationToken}&Central-Token={centralAccessToken}';
        this.USERS_CURRENT = '/central-users/current';
        this.UPDATE_CENTRAL_USER = '/central-users/update';
        this.centralUserFetched = new Subject();
        this.centralUserFetched$ = this.centralUserFetched.asObservable();
    }
    userChangePasswordRequest(passwordChange) {
        return this.authHttp.post(this.CHANGE_PASSWORD, JSON.stringify(passwordChange)).pipe(map(result => {
            return true;
        }));
    }
    sendContactAdmin(contactAdmin) {
        return this.http.post('/paginas/contact_admin.php', contactAdmin).pipe(map(result => {
            return true;
        }));
    }
    findAllUsers(q) {
        return this.authHttp.get('/users?q=' + (q != null ? encodeURIComponent(q) : ''), null, null, true).pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new User().deserialize(item);
            });
        }));
    }
    getCurrentVersion() {
        return this.http.get('/version.json').pipe(map(result => {
            let r = result;
            return r.version;
        }));
    }
    /**
     * Get current logged in user
     */
    getCurrentUser() {
        return this.authHttp.get(this.CURRENT_USER).pipe(map(result => {
            return new User().deserialize(result.body);
        }));
    }
    /**
     * Let a user join a platform
     */
    joinPlatform(joinToken, email, platformURL, centralAccessToken, centralUserId, activationToken) {
        let jsonParam = {
            joinToken: joinToken,
            email: email,
            centralUserId: centralUserId != null ? centralUserId : '',
            activationToken: activationToken != null ? activationToken : '',
            centralAccessToken: centralAccessToken != null ? centralAccessToken : ''
        };
        return this.authHttp.get(ApiUtil.processApiUrl(this.JOIN_PLATFORM, jsonParam), null, null, null, null, platformURL).pipe(map(result => {
            return result.body;
        }));
    }
    /**
     * Get current central user
     */
    getCurrentCentralUser(prod) {
        let centralAccessToken = this.cookieService.getCentralCookie('central_access_token', prod);
        if (centralAccessToken == null || centralAccessToken == '') {
            let centralRefreshToken = this.cookieService.getCentralCookie('central_refresh_token', prod);
            if (centralRefreshToken == null || centralRefreshToken == '') {
                return Observable.create((observer) => {
                    let error = new ApiError();
                    error.status = BAD_REQUEST;
                    error.message = 'No refresh token available to refresh the central login tokens!';
                    observer.error(error);
                });
            }
            else {
                return Observable.create((observer) => {
                    this.authenticationService.refreshCentralAccessToken(localStorage.getItem('userEmail'), centralRefreshToken, null).subscribe((_tokenResult) => {
                        if (_tokenResult.access_token) {
                            this.authHttp.get(this.USERS_CURRENT, null, null, null, _tokenResult.access_token).subscribe((user) => {
                                observer.next(new UserDTO().deserialize(user.body));
                            });
                        }
                        else {
                            let error = new ApiError();
                            error.status = BAD_REQUEST;
                            error.message = 'No access token found after refresh!';
                            observer.error(error);
                        }
                    });
                });
            }
        }
        else {
            return this.authHttp.get(this.USERS_CURRENT, null, null, null, centralAccessToken).pipe(map(result => {
                return new UserDTO().deserialize(result.body);
            }));
        }
    }
    /**
     * Update a central user
     * @param centralUser
     * @param centralAccessToken
     */
    updateCentralUser(centralUser, centralAccessToken) {
        return this.authHttp.put(this.UPDATE_CENTRAL_USER, JSON.stringify(centralUser), null, centralAccessToken).pipe(map(result => {
            return new UserDTO().deserialize(result.body);
        }));
    }
    /**
     * Signal all subscribed locations that a central user has been fetched
     */
    triggerCentralUserFetched(centralUser) {
        this.centralUserFetched.next(centralUser);
    }
}
CommonUserService.ɵfac = function CommonUserService_Factory(t) { return new (t || CommonUserService)(ɵɵinject(HttpAuthentication), ɵɵinject(CommonCacheService), ɵɵinject(HttpClient), ɵɵinject(CookieService), ɵɵinject(AuthenticationService)); };
CommonUserService.ɵprov = ɵɵdefineInjectable({ token: CommonUserService, factory: CommonUserService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CommonUserService, [{
        type: Injectable
    }], function () { return [{ type: HttpAuthentication }, { type: CommonCacheService }, { type: HttpClient }, { type: CookieService }, { type: AuthenticationService }]; }, null); })();

class AgeCategory {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class AbsenceReason extends Translatable {
    constructor() {
        super(...arguments);
        this.individual = false;
        this.active = true;
    }
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        return this;
    }
    get reason() {
        return this.getLabel();
    }
    set reason(reason) {
        this._reason = reason;
    }
}

class Arbitration {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class GameRound {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class GameTable {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class TrainingTypes {
}
TrainingTypes.GROUP = "groep";
TrainingTypes.INDIVIDUAL = "individueel";
TrainingTypes.KEEPER = "keeper";
TrainingTypes.SCHOOL = "school";

class TrainingType extends Translatable {
    deserialize(json) {
        super.deserialize(json);
        deserializeProperties(json, this);
        if (json.absenceReason != null) {
            this.absenceReason = new AbsenceReason().deserialize(json.absenceReason);
        }
        return this;
    }
    get durationAsTime() {
        if (this._durationAsTime == null) {
            this._durationAsTime = DateTimeUtil.getTimeFromMins(this.duration);
        }
        return this._durationAsTime;
    }
    get name() {
        if (this.getLabel() != null) {
            return this.getLabel();
        }
        else {
            return this._name;
        }
    }
    set name(name) {
        this._name = name;
    }
    get defaultAttendance() {
        if (this._defaultAttendance == null) {
            if (this.absenceReason != null) {
                this._defaultAttendance = 'absent';
            }
            else {
                this._defaultAttendance = 'present';
            }
        }
        return this._defaultAttendance;
    }
    set defaultAttendance(defaultAttendance) {
        this._defaultAttendance = defaultAttendance;
    }
    get groupType() {
        return this.type == TrainingTypes.GROUP;
    }
    get individualType() {
        return this.type == TrainingTypes.INDIVIDUAL;
    }
    get schoolType() {
        return this.type == TrainingTypes.SCHOOL;
    }
    get keeperType() {
        return this.type == TrainingTypes.KEEPER;
    }
}

class TrainingSubType {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class ReasonNotSelected {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class RepetitionType {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class BenchmarkCompareWithPosition {
    constructor(_positionId, _position) {
        this.positionId = _positionId;
        this.position = _position;
    }
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class DataListService extends BaseService {
    constructor(authHttp, cacheService, translateService) {
        super();
        this.authHttp = authHttp;
        this.cacheService = cacheService;
        this.translateService = translateService;
        this.ABSENCE_REASONS_EXPECTED = '/datalists/absencereasons?expected=true';
        this.ABSENCE_REASONS = '/datalists/absencereasons';
        this.PAYMENT_PROVIDER_TYPES = '/datalists/paymentprovidertypes';
        this.TRAINING_TYPES = '/datalists/trainingtypes?type={type}';
    }
    getAgeCategories() {
        return this.cacheService.getCached('agecategories', CommonCacheService.CACHE_AGECATEGORY, this.authHttp.get('/datalists/agecategories').pipe(map(result => {
            if (result && result.body && result.body.content) {
                return deserializeList(result.body.content, function (item) {
                    return new AgeCategory().deserialize(item);
                });
            }
            else {
                return null;
            }
        })));
    }
    getAbsenceReasons(expected) {
        let apiUrl = this.ABSENCE_REASONS;
        if (expected) {
            apiUrl = this.ABSENCE_REASONS_EXPECTED;
        }
        return this.authHttp.get(apiUrl).pipe(map(result => {
            if (result && result.body) {
                return deserializeList(result.body.content, function (item) {
                    return new AbsenceReason().deserialize(item);
                });
            }
            else {
                return null;
            }
        }));
    }
    getTrainingTypes(type) {
        return this.authHttp.get(ApiUtil.processApiUrl(this.TRAINING_TYPES, { type: type })).pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new TrainingType().deserialize(item);
            });
        }));
    }
    getTrainingSubTypes() {
        return this.authHttp.get('/datalists/trainingsubtypes').pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new TrainingSubType().deserialize(item);
            });
        }));
    }
    getArbitrations() {
        return this.authHttp.get('/datalists/arbitrations').pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new Arbitration().deserialize(item);
            });
        }));
    }
    getBenchmarkCompareTimeReferenceTypes() {
        return this.authHttp.get('/datalists/benchmarkcomparetimereferencetypes').pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return item;
            });
        }));
    }
    getCentralTeams() {
        return this.authHttp.get('/datalists/centralteams').pipe(map(result => {
            if (result && result.body && result.body.content && result.body.content.length > 0) {
                return deserializeList(result.body.content, function (item) {
                    return new CentralTeam().deserialize(item);
                });
            }
            else {
                return null;
            }
        }));
    }
    getCertificates() {
        return this.authHttp.get('/datalists/certificates').pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new Certificate().deserialize(item);
            });
        }));
    }
    getContracts() {
        return this.cacheService.getCached('contracts', CommonCacheService.CACHE_CONTRACT, this.authHttp.get('/datalists/contracts').pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new Contract().deserialize(item);
            });
        })));
    }
    getCountries() {
        return this.cacheService.getCached('countries', CommonCacheService.CACHE_COUNTRY, this.authHttp.get('/datalists/countries').pipe(map(result => {
            let me = this;
            return deserializeList(result.body.content, function (item) {
                let country = new Country().deserialize(item);
                country.name = me.translateService.instant(country.name);
                return country;
            });
        })));
    }
    getCreditNoteStatuses() {
        return this.authHttp.get('/datalists/creditNoteStatuses').pipe(map(result => {
            return result.body;
        }));
    }
    getCurrencies() {
        return this.authHttp.get('/datalists/currencies').pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new Currency().deserialize(item);
            });
        }));
    }
    getGameRounds() {
        return this.cacheService.getCached('gamerounds', CommonCacheService.CACHE_GAMEROUND, this.authHttp.get('/datalists/gamerounds').pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new GameRound().deserialize(item);
            });
        })));
    }
    getGameTables() {
        return this.cacheService.getCached('gametables', CommonCacheService.CACHE_GAMETABLE, this.authHttp.get('/datalists/gametables').pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new GameTable().deserialize(item);
            });
        })));
    }
    getFieldOccupations() {
        return this.cacheService.getCached('fieldoccupations', CommonCacheService.CACHE_COUNTRY, this.authHttp.get('/datalists/fieldoccupations').pipe(map(result => {
            if (result && result.body) {
                return deserializeList(result.body.content, function (item) {
                    return new FieldOccupation().deserialize(item);
                });
            }
            else {
                return EMPTY;
            }
        })));
    }
    getLanguages() {
        return this.cacheService.getCached('languages', CommonCacheService.CACHE_LANGUAGES, this.authHttp.get('/datalists/languages').pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new Language().deserialize(item);
            });
        })));
    }
    getBenchmarkCompareWithPosition() {
        return this.authHttp.get('/datalists/positions').pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new BenchmarkCompareWithPosition(item.id, item.name).deserialize(item);
            });
        }));
    }
    getPositions() {
        return this.authHttp.get('/datalists/positions').pipe(map(result => {
            if (result && result.body) {
                return deserializeList(result.body.content, function (item) {
                    return new Position().deserialize(item);
                });
            }
            else {
                return null;
            }
        }));
    }
    getReasonsNotSelected() {
        return this.authHttp.get('/datalists/reasonsnotselected').pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new ReasonNotSelected().deserialize(item);
            });
        }));
    }
    getScoutingRatings() {
        return this.authHttp.get('/datalists/scoutingratings').pipe(map(result => {
            return deserializeList(result.body.content, function (item) {
                return new ScoutingRating().deserialize(item);
            });
        }));
    }
    getSurfaces() {
        let me = this;
        return this.cacheService.getCached('surfaces', CommonCacheService.CACHE_SURFACES, this.authHttp.get('/datalists/surfaces').pipe(map(result => {
            if (result && result.body && result.body.content) {
                return deserializeList(result.body.content, function (item) {
                    let surface = new Surface().deserialize(item);
                    surface.name = me.translateService.instant('surface.' + surface.name);
                    return surface;
                });
            }
            else {
                return null;
            }
        })));
    }
    getFeet() {
        return this.cacheService.getCached('feet', CommonCacheService.CACHE_SURFACES, this.authHttp.get('/datalists/feet').pipe(map(result => {
            if (result && result.body) {
                return deserializeList(result.body.content, function (item) {
                    return new Foot().deserialize(item);
                });
            }
            else {
                return null;
            }
        })));
    }
    getAllMemberLanguages() {
        return this.cacheService.getCached('memberlanguages', CommonCacheService.CACHE_LANGUAGES, this.authHttp.get('/datalists/languages/all').pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new MemberLanguage().deserialize(item);
            });
        })));
    }
    getRepetitionTypes() {
        return this.authHttp.get('/datalists/repetitiontypes').pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new RepetitionType().deserialize(item);
            });
        }));
    }
    getTransportArrangements() {
        return this.authHttp.get('/datalists/transportarrangements').pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return item;
            });
        }));
    }
    getPaymentProviders() {
        return this.authHttp.get(this.PAYMENT_PROVIDER_TYPES).pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return item;
            });
        }));
    }
}
DataListService.ɵfac = function DataListService_Factory(t) { return new (t || DataListService)(ɵɵinject(HttpAuthentication), ɵɵinject(CommonCacheService), ɵɵinject(TranslateService)); };
DataListService.ɵprov = ɵɵdefineInjectable({ token: DataListService, factory: DataListService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DataListService, [{
        type: Injectable
    }], function () { return [{ type: HttpAuthentication }, { type: CommonCacheService }, { type: TranslateService }]; }, null); })();

class Tab {
    deserialize(json) {
        deserializeProperties(json, this);
        return this;
    }
}

class ModuleService extends BaseService {
    constructor(authHttp, configParamsService) {
        super();
        this.authHttp = authHttp;
        this.configParamsService = configParamsService;
        this._modules = null;
        this.cachedModules = {};
    }
    getSecureTabs(moduleName, memberId) {
        return this.authHttp.get('/modules/' + moduleName + '/securetabs/' + memberId).pipe(map(tabsJson => {
            let tabs = new Array();
            if (tabsJson && tabsJson.body) {
                for (let tab of tabsJson.body) {
                    tabs.push(new Tab().deserialize(tab));
                }
            }
            return tabs;
        }));
    }
    getModulesJSON() {
        if (this._modules == null) {
            this._modules = JSON.parse(this.configParamsService.getConfigParam('modules'));
        }
        return this._modules;
    }
    hasModule(moduleName) {
        let hasModule = false;
        if (this.cachedModules[moduleName] != null) {
            return this.cachedModules[moduleName];
        }
        else {
            let modules = this.getModulesJSON();
            if (modules != null) {
                for (let m of modules) {
                    if (m.name == moduleName) {
                        hasModule = true;
                        break;
                    }
                }
                this.cachedModules[moduleName] = hasModule;
            }
        }
        return hasModule;
    }
    initPlatformModules() {
        return this.authHttp.get('/modules').pipe(map(modulesJson => {
            this.configParamsService.setConfigParam('modules', JSON.stringify(modulesJson.body));
            return JSON.stringify(modulesJson.body);
        }));
    }
    getRightModules() {
        return this.authHttp.get('/modules').pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new Module().deserialize(item);
            });
        }));
    }
    getAllTopModules() {
        return this.authHttp.get('/modules/topmodules').pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new Module().deserialize(item);
            });
        }));
    }
}
ModuleService.ɵfac = function ModuleService_Factory(t) { return new (t || ModuleService)(ɵɵinject(HttpAuthentication), ɵɵinject(ConfigParamsService)); };
ModuleService.ɵprov = ɵɵdefineInjectable({ token: ModuleService, factory: ModuleService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ModuleService, [{
        type: Injectable
    }], function () { return [{ type: HttpAuthentication }, { type: ConfigParamsService }]; }, null); })();

class PlatformPackageService extends BaseService {
    constructor(authHttp) {
        super();
        this.authHttp = authHttp;
        this.PLATFORM_PACKAGES = '/platformpackages/trial-creation';
        this.PLATFORM_PACKAGE_MODULES = '/config/platformpackages/{package}/modules';
    }
    getPlatformPackages() {
        return this.authHttp.get(this.PLATFORM_PACKAGES).pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new PlatformPackage().deserialize(item);
            });
        }));
    }
    getPlatformPackageModules(selectedPackage) {
        let paramObj = { package: selectedPackage };
        return this.authHttp.get(ApiUtil.processApiUrl(this.PLATFORM_PACKAGE_MODULES, paramObj)).pipe(map(result => {
            return deserializeList(result.body, function (item) {
                return new PlatformPackage().deserialize(item);
            });
        }));
    }
}
PlatformPackageService.ɵfac = function PlatformPackageService_Factory(t) { return new (t || PlatformPackageService)(ɵɵinject(HttpAuthentication)); };
PlatformPackageService.ɵprov = ɵɵdefineInjectable({ token: PlatformPackageService, factory: PlatformPackageService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PlatformPackageService, [{
        type: Injectable
    }], function () { return [{ type: HttpAuthentication }]; }, null); })();

class TranslationService extends BaseService {
    constructor(authHttp, http, cacheService) {
        super();
        this.authHttp = authHttp;
        this.http = http;
        this.cacheService = cacheService;
    }
    getTranslations(language) {
        return this.cacheService.getCached('translations-' + language, 'translations', this.http.get(localStorage.getItem('apiBaseURL') + '/translations/' + language).pipe(map(result => {
            return result;
        })));
    }
}
TranslationService.ɵfac = function TranslationService_Factory(t) { return new (t || TranslationService)(ɵɵinject(HttpAuthentication), ɵɵinject(HttpClient), ɵɵinject(CommonCacheService)); };
TranslationService.ɵprov = ɵɵdefineInjectable({ token: TranslationService, factory: TranslationService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TranslationService, [{
        type: Injectable
    }], function () { return [{ type: HttpAuthentication }, { type: HttpClient }, { type: CommonCacheService }]; }, null); })();

class GlobalErrorHandler {
    handleError(error) {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (chunkFailedMessage.test(error.message)) {
            window.location.reload();
        }
        else if (localStorage.getItem('environment') != 'DEV') {
            captureException(error.originalError || error);
        }
    }
}
GlobalErrorHandler.ɵfac = function GlobalErrorHandler_Factory(t) { return new (t || GlobalErrorHandler)(); };
GlobalErrorHandler.ɵprov = ɵɵdefineInjectable({ token: GlobalErrorHandler, factory: GlobalErrorHandler.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GlobalErrorHandler, [{
        type: Injectable
    }], null, null); })();

/**
 * Public API Surface of psd-common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APP_INJECTOR, Action, AddClubDTO, ApiError, AuthenticationService, BaseService, BillingService, Cache, CacheItem, CentralUserEmailStatusDTO, ChangePasswordDTO, Club, ClubSearchDTO, ClubService, ClubTaskTypeEnum, CommonBusyDirective, CommonCacheService, CommonCustomBusyComponent, CommonPlatformService, CommonUserService, CommonUtil, CompetitionTypeEnum, ConfigParamsService, ConfigService, CookieService, CookieUtil, Country, CreateCentralUserDTO, CustomPreloadingStrategyService, DataListService, DataSourceTypeEnum, DataTransferDestinationStatusEnum, DataTransferStatusEnum, DataTransferTypeEnum, DateTimeUtil, DiscountCodeStatusEnum, DiscountCodeTypeEnum, DiscountTypeEnum, ErrorMessageEnum, GameEventSubtypeEnum, GameEventTypeEnum, GameOfficialRoleEnum, GameStatusEnum, GenderTypeEnum, GlobalErrorHandler, HttpAuthentication, Language, LanguageEnum, LinkUtil, LogoSizeEnum, Member, MemberStatusEnum, MergeStatusEnum, Module, ModuleService, ModuleSubTypeEnum, ModuleTypeEnum, OnboardingStepEnum, OnboardingTaskEnum, PSDTranslateLoader, PasswordStrengthValidator, PaymentSessionCreate, Platform, PlatformComponentType, PlatformDataConnectionTypeEnum, PlatformPackage, PlatformPackageEnum, PlatformPackageService, PlatformStatusEnum, PlatformSubscriptionPaymentFlowEnum, PlatformUserDto, PlatformValidityEnum, PsdCommonModule, ReportingDataSetTypeEnum, ReportingDatasetColumnTypeEnum, ReportingParamTypeEnum, ResetPasswordDTO, ScopeEnum, SearchDocumentTypeEnum, SelectUserDTO, SportsTypeEnum, StatusEnum, StreamLogStatusEnum, TeamOfficialRoleEnum, Toaster, TranslationService, TrialPlatformDTO, URLParams, UserDTO, UserUtil, deserializeList, deserializeProperties };
//# sourceMappingURL=psd-common.js.map
